import Colors from "../../../config/colors";
import { handleSnackBar, invokePostService,  setReRender,  } from "../../../store/global/actions";
import { enableHorizontalAutoScrollOnDrag, enableVerticalAutoScrollOnDrag, findDepth, getElementsToRemoveOnDrag, getNewEventTargetsOnEventDrag, handleDraggingEventElements, hideAllCirclesOnNode, removeArrowGroups, removeDragHandlerFromEventAndChildTxn, removeEventArrowElements, removeNodeCircles, removeRectFromBottomToTop, removeRectsFromBottomToTop, renderCircleOnNode, renderNoConnectionAlert, resetDraggingEventElementsOnIDrop, updateElementsOrder, updateGroupYPosition } from "../../../utils/raphaelHelpers";
import {  getTextWidth } from '../../../utils/transactionUtils';
const { Raphael } = require('react-raphael');

export class ArrowManager {
  constructor({diagramManager, paper, nodeManager, dispatch, connections, events, messages, clusterlets, transactions, selectedTransaction, handleSelectedItem, handleDeleteItem, firstLevelChildTransactions, setQuickViewMessages,onElementRename, removeExistingInlineInput, utilityFunctions, setSelectedUtilityFunction} ) {
    this.diagramManager = diagramManager;
    this.paper = paper;
    this.events = events;
    this.messages = messages;
    this.transactions = transactions;
    this.diagramManager = diagramManager;
    this.nodeManager = nodeManager;
    this.dispatch = dispatch;
    this.selectedTransaction = selectedTransaction;
    this.setQuickViewMessages = setQuickViewMessages;
    this.setSelectedUtilityFunction = setSelectedUtilityFunction;
    this.clusterlets = clusterlets;
    this.utilityFunctions = utilityFunctions;
    this.eventArrows = {};
    this.childTransactions = {};
    this.drawnEvents = [];
    this.drawnChildTransactions = [];
    this.collapsedState  = {};
    this.potentialDroppableNodes = {}; //To store the node positions when dragging event horizontally
    this.nodeCircles = []; //To strore Circle elements created to show as droppable locations
    this.connections = connections;
    this.transactionChildrenGroups = {}; // { parentTxId: Raphael.set of children }
    this.transactionBackgrounds = {};
    this.expandChidTransactionYPosition = 30;
    this.selectedTransactionElement = null;
    this.drawnInvokedTransactions = [];
    this.invokedTransactions = {};
    this.wrapperWidth = 80;
    this.transactionPopups = {};
    this.draggableItems = []; // Combined array of all draggable event/transaction elements
    this.verticalDragSpacing = 60; // Standard vertical space between elements
    this.currentInsertionLine = null; // To hold the Raphael path for the insertion line
    this.isReordering = false; //
    this.handleSelectedItem = handleSelectedItem;
    this.handleDeleteItem = handleDeleteItem;
    this.nodesForPlusCircle = {};
    this.transactionElemnts = {};
    this.expandedChildTransactions={};
    this.lastExpandedChild = null;
    this.disableExpandButtonClick = false;
    this.onElementRename = onElementRename;
    this.removeExistingInlineInput = removeExistingInlineInput;
    this.handlerWidth = 20;
    this.handlerHeight = 24;

    firstLevelChildTransactions?.forEach(txn => (this.expandedChildTransactions[txn] = true));
  }

  icons={
    deleteIcon : `${process.env.PUBLIC_URL}/ide_icons/delete_latest.svg`,
    expandIcon : `${process.env.PUBLIC_URL}/ide_icons/collapse.svg`,
    collapseIcon : `${process.env.PUBLIC_URL}/ide_icons/expand.svg`,
    dragHandle : `${process.env.PUBLIC_URL}/ide_icons/event_drag_handler.svg`,
    quickView: '/ide_icons/quick-view.svg',
    condition: `${process.env.PUBLIC_URL}/ide_icons/condition_icon.svg`,
    loop: `${process.env.PUBLIC_URL}/ide_icons/loop_icon.svg`,
    oneof: `${process.env.PUBLIC_URL}/ide_icons/oneof_icon.svg`,
    info: `${process.env.PUBLIC_URL}/ide_icons/info_icon.svg`,
    alert: `${process.env.PUBLIC_URL}/ide_icons/alert_icon.svg`
  }

  // === Utility Constants ===
  horizontalDragHandlerConfig = {
    handlerWidth : 20,
    handlerHeight : 24,
    wrapperRectangleHeight: 24,
    wrapperRectangleWidth: 50
  }


  labelBoxConfig = {
    width: 140,
    height: 24,
    padding: 6,
    charWidth: 6.5,
    fontSize: 10,
    mouseOverFill: "#fcfc69"
  };

  deleteButtonConfig = {
    width: 20,
    height: 20
  }

  dragBoxConfig = {
    width: 12,
    height: 24,
    spacing: 4,
    dotRadius: 1.2,
    dotSpacing: 4,
  };


  handlerBoxConfig = {
    width: 21,
    height: 21,
    onsendColor: Colors.dataflow.onsendBox,
    onrecvColor: Colors.dataflow.onrecvBox,
    onsendColorMouseOver:  "#196740",
    onrecvColorMouseOver: "#a45128",
  }

  attributeConfig = {
    iconSize: 22,
    infoIconSize: 18,
    labelBoxHeight: 22,
  }


  updateTransactionData(data){
    const {selectedTransaction, events, clusterlets, connections, transactionEvents,  transactions, messages} = data;
    if(selectedTransaction) this.selectedTransaction = selectedTransaction;
    if(events) this.events = events;
    if(clusterlets) this.clusterlets = clusterlets;
    if(transactions) this.transactions = transactions;
    if(connections) this.connections = connections;
    if(transactionEvents) this.transactionEvents = transactionEvents;
    if(messages) this.messages = messages
  }

  // === Helper Methods ===

  truncateLabel(label, isTx) {

    const actualLabelWidth  = isTx ? this.labelBoxConfig.width - 10 : this.labelBoxConfig.width;

    const maxWidth = actualLabelWidth - 2 * this.labelBoxConfig.padding;


    const ctx = document.createElement("canvas").getContext("2d");
    ctx.font = this.labelBoxConfig.font || "12px Arial"; // match your label font

    let result = "";
    for (let i = 0; i < label.length; i++) {
      const testStr = result + label[i];
      const width = ctx.measureText(testStr + "…").width;

      if (width > maxWidth) {
        return result + "…";
      }
      result += label[i];
    }

    return label; // fits i
  }

  renderVerticalDragHandle({x, y, group, elementId, elementType, data}) {
    const { width, height } = this.handlerBoxConfig;

    const dragHandleRectangle = this.paper.image(this.icons.dragHandle, x,y, this.handlerWidth, height)
      .attr({ cursor: "ns-resize", title: "Click and drag vertically to reorder element"  });
    dragHandleRectangle.toFront();
    group.push(dragHandleRectangle);

    dragHandleRectangle.node.setAttribute("id", `${elementType}_${data?.name}_verticalDragHandle`);
    dragHandleRectangle.node.setAttribute("data-ui-tour-id", `vertical-drag-handle`);


    dragHandleRectangle.data({
      id: elementId,
      type: elementType,
      initialX: x, // Store initial X for relative positioning
      initialY: y // Store initial Y for relative positioning
    });


    dragHandleRectangle?.mouseover(() => {
      this.nodeManager?.hidePopUpSet();
      this.diagramManager?.removeHoveringHighlight();
    })

    return {verticalDragHandler: dragHandleRectangle, labelX: x + width + this.dragBoxConfig.spacing};
  }

  calculateNewIndex(oldIndex, offsetY) {
    const spacing = this.verticalDragSpacing;
    const shift = Math.round(offsetY / spacing);
    let newIndex = oldIndex + shift;
    newIndex = Math.max(0, Math.min(this.draggableItems.length - 1, newIndex));
    return newIndex;
  }


  /**
 * Renders a drag handler icon for extending events horizontally.
 * @param {Object} options
 * @param {number} options.x1 - Start X position of the event.
 * @param {number} options.x2 - End X position of the event.
 * @param {number} options.midY - Middle Y position for vertical alignment.
 * @param {boolean} [options.onrecv=false] - Whether this is an onrecv-type event.
 * @param {string} options.target - Target node ID for the event.
 * @returns {{dragHandlerWrapper: RaphaelElement, dragHandler: RaphaelElement} | null}
 */
renderEventHorizontalDragHandler({id, x1, x2, midY, onrecv = false, target }) {
  const eventData = this.events?.find(item => item?._id === id);

  // Config
  const handlerBoxWidth = this.handlerBoxConfig?.width || 22;
  const {handlerWidth, handlerHeight, wrapperRectangleHeight, wrapperRectangleWidth} = this.horizontalDragHandlerConfig;
  const isEventToRight = x1 < x2;

  let wrapperWidth = onrecv ? wrapperRectangleWidth-handlerBoxWidth/2 : wrapperRectangleWidth;

  let wrapperX = x2;
  let dragHandlerX = 0;
  if(isEventToRight){
    wrapperX  = x2 - wrapperRectangleWidth;
    dragHandlerX = x2 - 30;

    if(onrecv) dragHandlerX += -10;
  }else{
    wrapperX = onrecv ? (x2 + handlerWidth / 2) : x2;
    dragHandlerX = x2 + handlerWidth / 2;
    wrapperWidth = wrapperRectangleWidth/2;

    if(onrecv){
      dragHandlerX += 10;
    }
  }

  // Draw invisible wrapper for mouse events
  const dragHandlerWrapper = this.paper.rect(
    wrapperX,
    midY - wrapperRectangleHeight / 2,
    wrapperWidth,
    wrapperRectangleHeight
  ).attr({
    fill: "transparent",
    stroke: "transparent",
    "stroke-width": 1,
    rx: 6,
    ry: 6,
  });
  dragHandlerWrapper.node.setAttribute("id", `event_${eventData?.name}_horizontalDragHandleWrapper`);

  // Draw the drag handler icon (hidden by default)
  const dragHandler = this.paper.image(
    this.icons.dragHandle,
    dragHandlerX,
    midY - handlerHeight / 2,
    handlerWidth,
    handlerHeight
  ).attr({ cursor: "ew-resize", title: "Click and drag to extend event" }).hide();

  dragHandler.node.setAttribute("id", `event_${eventData?.name}_horizontalDragHandle`);


  dragHandler.toFront();

  // Hover interaction: show/hide on wrapper or icon hover
  const showHandler = () => {
    this.nodeManager?.hidePopUpSet();
    this.diagramManager?.removeHoveringHighlight();

    dragHandler.show();

  };
  const hideHandler = () => dragHandler.hide();

  dragHandlerWrapper.mouseover(showHandler);
  dragHandlerWrapper.mouseout(hideHandler);
  dragHandler.mouseover(showHandler);
  dragHandler.mouseout(hideHandler);

  return { dragHandlerWrapper, dragHandler };
}

truncateEventLabel (label, maxWidth) {
  if (!label) return "";

  // create a temporary text element (offscreen)
  const tempText = this.paper.text(-9999, -9999, label).attr({
    "font-size": this.labelBoxConfig.fontSize,
    "text-anchor": "start"
  });

  let truncated = label;

  // check if full label fits
  if (tempText.getBBox().width <= maxWidth) {
    tempText.remove();
    return label;
  }

  // otherwise shrink until it fits
  for (let i = label.length - 1; i > 0; i--) {
    truncated = label.substring(0, i) + "...";
    tempText.attr("text", truncated);

    if (tempText.getBBox().width <= maxWidth) {
      break;
    }
  }

  tempText.remove();
  return truncated;
}

  splitLabel(label){
    const actualLabelWidth = this.labelBoxConfig.width;

    const maxWidth =
      actualLabelWidth - 2 * this.labelBoxConfig.padding;

    const ctx = document.createElement("canvas").getContext("2d");
    ctx.font = this.labelBoxConfig.font || "12px Arial";

    const tokens = this._tokenizePreservingChars(label);

    const lines = [];
    let currentLine = "";

    for (const token of tokens) {
      const testLine = currentLine + token;

      if (ctx.measureText(testLine).width <= maxWidth) {
        currentLine = testLine;
      } else {
        if (currentLine) {
          lines.push(currentLine);
          currentLine = token;
        } else {
          // Single token too wide → hard wrap without mutation
          lines.push(...this._hardWrap(token, maxWidth, ctx));
          currentLine = "";
        }
      }
    }

    if (currentLine) {
      lines.push(currentLine);
    }

    return lines;

  }

  _tokenizePreservingChars(label) {
    const tokens = [];
    let buffer = "";
  
    for (let i = 0; i < label.length; i++) {
      const char = label[i];
      const prev = label[i - 1];
      const next = label[i + 1];
  
      // Snake_case boundary → split AFTER `_`
      if (char === "_") {
        buffer += char;
        tokens.push(buffer);
        buffer = "";
        continue;
      }
  
      // camelCase / PascalCase boundary
      if (
        prev &&
        /[a-z0-9]/.test(prev) &&
        /[A-Z]/.test(char)
      ) {
        tokens.push(buffer);
        buffer = char;
        continue;
      }
  
      buffer += char;
    }
  
    if (buffer) tokens.push(buffer);
    return tokens;
  }

  _hardWrap(text, maxWidth, ctx) {
    const lines = [];
    let current = "";
  
    for (const char of text) {
      const test = current + char;
      if (ctx.measureText(test).width <= maxWidth) {
        current = test;
      } else {
        lines.push(current);
        current = char;
      }
    }
  
    if (current) lines.push(current);
    return lines;
  }

  setMultilineText(labelText, lines) {
    const node = labelText.node;
    const fontSize = this.labelBoxConfig.fontSize;
    const lineHeight = fontSize * 1.2;
  
    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  
    const x = node.getAttribute("x");
    const startDy = -((lines.length - 1) * lineHeight) / 2;
  
    lines.forEach((line, i) => {
      const tspan = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "tspan"
      );
  
      tspan.setAttribute("x", x);
      tspan.setAttribute("dy", i === 0 ? 3 : lineHeight);
  
      tspan.textContent = line;
      node.appendChild(tspan);
    });
  }
  


  renderEventLabel(id, midX, midY, label, group, showFullText, pathLength, parentId) {
    const eventData = this.events?.find(item => item?._id === id);
    const maxAllowedWidth = pathLength * 0.75;
    let myself = this;


    const truncated = showFullText ? label : this.truncateLabel(label);
    const labels = this.splitLabel(label);

    
    const { width, height } = this.labelBoxConfig;
    const padding = 5;

    const event = this.events?.find(item => item?._id === id) ;


    const labelRectangle = this.paper.rect(
      midX - width / 2 + 15,
      midY - height / 2,
      width,
      height,
      4
    ).attr({
      "fill": Colors.white,
      "stroke": Colors.black,
      "stroke-width": 0,
      "cursor": 'pointer',
      //"title": event?.name || label
    });
    labelRectangle.node.setAttribute("id", `event_${eventData?.name}_labelBox`);


    const labelText = this.paper.text(midX + 15, midY - ((labels.length - 1) * 10) / 2).attr({
      "font-size": this.labelBoxConfig.fontSize,
      "text-anchor": "middle",
      "dominant-baseline": "middle",
      "fill": "#000",
      "cursor": 'pointer',
      "title": event?.name || label
    });
    labelText.node.setAttribute("id", `event_${eventData?.name}_labelText`);




    //STart

    let textBBox = labelText.getBBox();
    let boxWidth = textBBox.width + padding * 2;

    // if (!showFullText) {
      // Short path → always truncate
      this.setMultilineText(labelText, labels)

      const truncatedBBox = labelText.getBBox();
      boxWidth = Math.max(width, truncatedBBox.width + padding * 2);

    // Update rectangle after final width is determined
    labelRectangle.attr({
      width: boxWidth,
      x: midX - boxWidth / 2 + 15
    });


    group.push(labelRectangle, labelText);
    labelText.toFront();

    // Hightlight while mouse over
    labelRectangle.mouseover(() => {
      this.nodeManager?.hidePopUpSet();
      this.diagramManager?.hightlightHoverItem({id, type: "event"});
    })
    labelText.mouseover(() => {
      this.nodeManager?.hidePopUpSet();
      this.diagramManager?.hightlightHoverItem({id, type: "event"});
    })
    labelRectangle.mouseout(() => {
      this.diagramManager?.removeHoveringHighlight();
    })

    var nameGroup = this.paper.set();
    nameGroup.push(labelText, labelRectangle);


    let clickTimer;
    const clickDelay = 250; // adjust to taste
    
    nameGroup.click(function (e) {
      if (clickTimer) {
        // Second click within delay → double-click detected
        clearTimeout(clickTimer);
        clickTimer = null;
        onDoubleClick.call(this, e);
      } else {
        // First click → wait to see if another comes
        let self = this;
        clickTimer = setTimeout(function () {
          onSingleClick.call(self, e);
          clickTimer = null;
        }, clickDelay);
      }
    });
    
    function onSingleClick(e) {
      myself.diagramManager?.hightLighSelectedElementInDiagram({id, type: "event"});
      myself.handleSelectedItem({ id, type: "event", name: event?.name || label, data: eventData});
    }
    
    function onDoubleClick(e) {
      myself.makeLabelEditableInline({
        labelRectangle: labelRectangle,
        labelText: labelText,
        initialText: eventData?.name,
        onLabelUpdate: (newLabel) => {
          labelText.attr("text", myself.truncateLabel(newLabel) || eventData.name)
          const eventIndex = myself.drawnEvents.findIndex(ev => ev.id === id);
          if (eventIndex !== -1) myself.drawnEvents[eventIndex].label = newLabel;
          myself.onElementRename({id, item: eventData, mode:"edit", name:newLabel || eventData.name, protocol:undefined, transaction:parentId, type:"event"})
          myself.triggerUpdateElementNameApi(id,newLabel,"event")
          let updatedEvents = myself.updateElementName(newLabel, id, myself.events);
          myself.diagramManager.updateTransactionData({ events : updatedEvents})
          myself.updatePaperData();
        },
        type: "event"

      });
    }



    return {labelRectangle, labelText};
  }

  renderButtons({id, type, midX, midY, labelRectangle, labelText, uuid, parent=null, label, isMessageExist}){
    const labelBoxWidth = this.labelBoxConfig?.width;
    const labelBoxHeight = 24;

    const buttonWidth = this.deleteButtonConfig?.width;
    const buttonTitle = type === "nested_transaction" ? "child transaction" : type === "invoked_transaction" ? "invoked transaction"  : type;

    const labelBBox = labelRectangle.getBBox();

    const deleteWrapper = this.paper.rect(
      labelBBox.x,
      midY - (labelBoxHeight * 1.75) ,
      labelBBox.width,
      labelBoxHeight
    ).attr({
      stroke: 0,
      fill: '#fff',
      opacity: 0
    })

    deleteWrapper.toFront();
    const wrapperBox = deleteWrapper.getBBox();

    // Define padding
    const padding = 1;
    const gap = 6;

    // Calculate inner button size and position
    const btnX = wrapperBox.x + wrapperBox.width - buttonWidth;
    const btnY = wrapperBox.y - padding;

    const messageBtnX = (wrapperBox.x + wrapperBox.width - (buttonWidth * 2)) - gap

    // Create the button inside the wrapper
    const buttonContainer = this.paper.rect(
      btnX,
      btnY, 
      wrapperBox.height - (padding * 2), 
      wrapperBox.height - (padding * 2), 
      100
    ).attr({
      fill: '#fff', // red or any button color
      stroke: '#fff',
      'stroke-width': 0,
      cursor: 'pointer',
    }).attr({
      title: `Delete ${buttonTitle}`,
    });

    const messageSchemaButtonContainer = this.paper.rect(
      messageBtnX,
      btnY,
      wrapperBox.height - (padding * 2), 
      wrapperBox.height - (padding * 2), 
      100
    ).attr({
      fill: '#fff', // red or any button color
      stroke: '#fff',
      'stroke-width': 0,
      cursor: 'pointer',
    }).attr({
      title: `View event type`,
    });

    buttonContainer.hide()
    buttonContainer.animate({ opacity: 1 }, 300, 'easeIn')
    messageSchemaButtonContainer.hide()
    messageSchemaButtonContainer.animate({ opacity: 1 }, 300, 'easeIn')

    const buttonContainerBox = buttonContainer.getBBox()
    const messageSchemaContainerBox = messageSchemaButtonContainer.getBBox();

    // Step 1: Initially render with opacity 0
    const deleteButton = this.paper.image(
      this.icons.deleteIcon,
      // midX + labelBoxWidth / 2 - buttonWidth + (type === "event" ? 0 : 5),
      buttonContainerBox.x + 1,
      buttonContainerBox.y + 1,
      buttonContainerBox.width - 2,
      buttonContainerBox.height - 2
    ).attr({
      opacity: 0, // Start transparent
    });

    const messageButton = this.paper.image(
      this.icons.quickView,
      // midX + labelBoxWidth / 2 - buttonWidth + (type === "event" ? 0 : 5),
      messageSchemaContainerBox.x + 3,
      messageSchemaContainerBox.y + 3,
      messageSchemaContainerBox.width - 6,
      messageSchemaContainerBox.height - 6
    ).attr({
      opacity: 0, // Start transparent
      cursor: 'pointer',
      id: `${type}_${labelText}_quick`
    });

    messageButton.node.id = `${type}_${labelText}_quick`
    // Step 2: Animate fade-in
    deleteButton.animate({ opacity: 1 }, 300, 'easeIn');
    deleteButton.node.setAttribute("id", `${type}_${label}_delete`);
    messageButton.animate({ opacity: 1 }, 300, 'easeIn');
    messageButton.node.setAttribute("id", `${type}_${label}_quick`);

  
    deleteButton.toFront();
    deleteButton.hide();
    messageButton.toFront();
    messageButton.hide();

    deleteButton.mouseover(() => {
      deleteButton.node.setAttribute(
        "style",
        "filter: invert(27%) sepia(93%) saturate(7492%) hue-rotate(357deg) brightness(70%) contrast(120%); cursor: pointer;"
      );
    });
    deleteButton.mouseout(() => {
      deleteButton.node.setAttribute(
        "style",
        "filter: grayscale(100%) brightness(85%) contrast(100%); cursor: pointer;"
      );
    });

    const showDelete = () => {
      buttonContainer.show()
      deleteButton.show()
      if(type === "event" && isMessageExist){
        messageSchemaButtonContainer.show()
        messageButton.show()
      }
    };
    const hideDelete = () => {
      buttonContainer.hide()
      messageSchemaButtonContainer.hide()
      deleteButton.hide()
      messageButton.hide()
    };
    

    const hoverElement = [labelRectangle, labelText, deleteWrapper, buttonContainer, deleteButton, messageSchemaButtonContainer, messageButton]

    hoverElement.forEach((elem) => {
      elem.mouseover(showDelete);
      elem.mouseout(hideDelete);
    })

    deleteButton?.click(() => {
      if(type === "event"){
        const event = this.events?.find(item => item?._id === id);
        this.handleDeleteItem({id, type: "event", item: event, parent});
      } else if(type === "nested_transaction") {
        const transactionData = this.transactions.find(item => item._id  === id);
        if(transactionData !== undefined){
          this.handleDeleteItem({id, type: transactionData.type, name:transactionData.name, item: transactionData, parent});
        }
      } else if(type === "invoked_transaction"){
        const transactionData = this.transactions.find(item => item._id  === id);
        this.handleDeleteItem({id, type: transactionData?.type, name: transactionData.name, uuid,  item: transactionData, parent});
      }
    })

    messageButton?.click((ev) => {
      const event = this.events?.find(item => item?._id === id);
      const message = this.messages?.find(item => item.eventId === event._id);
    
      const x = ev.pageX - 200;
      const y = ev.pageY;
    
      this.setQuickViewMessages(prev => {
        if (prev.findIndex(item => item.message?.eventId === message?.eventId) === -1) {
          return [...prev, { x, y, message }];
        }
        return prev;
      });
    });

    const styledTooltip = this.diagramManager?.styledTooltip;

    messageButton.mouseover(() => {
      styledTooltip.innerText = "View event type"
      styledTooltip.style.fontSize = "0.8rem";
      styledTooltip.style.fontWeight = "400";
      styledTooltip.style.display = "block";
    })
    messageButton.mouseout(() => {
      styledTooltip.style.display = "none";
    });
    messageButton.mousemove((e) => {
      const tooltipOffsetY = 14;
      styledTooltip.style.left = `${e.clientX}px`;
      styledTooltip.style.top = `${e.clientY - tooltipOffsetY - 30}px`; // adjust Y to account for height + arrow
    });
    

    return { deleteButton, buttonContainer, messageButton, messageSchemaButtonContainer };
  }

  getRelativePoint(ev, containerEl) {
    if (!containerEl) return { x: 0, y: 0 };
  
    const rect = containerEl.getBoundingClientRect();
  
    // clientX/Y are viewport-based; rect.* are also viewport-based → subtract
    // Add the container's own scroll to get coordinates in its content space
    // Subtract clientLeft/Top to remove border thickness
    const x = ev.clientX - rect.left + containerEl.scrollLeft - containerEl.clientLeft;
    const y = ev.clientY - rect.top  + containerEl.scrollTop  - containerEl.clientTop;
  
    return { x, y };
  }

  renderDeleteButton({id, type, midX, midY, labelRectangle, labelText, uuid, parent=null, label }){
    const labelBoxWidth = this.labelBoxConfig?.width;
    const labelBoxHeight = this.labelBoxConfig?.height;

    const buttonWidth = this.deleteButtonConfig?.width;
    const buttonTitle = type === "nested_transaction" ? "child transaction" : type === "invoked_transaction" ? "invoked transaction"  : type;

    const labelBBox = labelRectangle.getBBox();

    const deleteWrapper = this.paper.rect(
      labelBBox.x + labelBBox.width - (labelBoxWidth / 2),
      midY - (labelBoxHeight * 1.5) ,
      labelBoxWidth / 2,
      labelBoxHeight
    ).attr({
      stroke: 0,
      fill: '#fff',
      opacity: 0
    })

    deleteWrapper.toFront();
    const wrapperBox = deleteWrapper.getBBox();

    // Define padding
    const padding = 3;

    // Calculate inner button size and position
    const btnX = wrapperBox.x + wrapperBox.width - buttonWidth;
    const btnY = wrapperBox.y + padding;

    // Create the button inside the wrapper
    const buttonContainer = this.paper.rect(btnX, btnY, wrapperBox.height - (padding * 2), wrapperBox.height - (padding * 2), 100).attr({
      fill: '#fff', // red or any button color
      stroke: '#fff',
      'stroke-width': 0,
      cursor: 'pointer',
    }).attr({
      title: `Delete ${buttonTitle}`,
    });

    buttonContainer.hide()
    buttonContainer.animate({ opacity: 1 }, 300, 'easeIn')


    const buttonContainerBox = buttonContainer.getBBox()

    // Step 1: Initially render with opacity 0
    const deleteButton = this.paper.image(
      this.icons.deleteIcon,
      // midX + labelBoxWidth / 2 - buttonWidth + (type === "event" ? 0 : 5),
      buttonContainerBox.x + 1,
      buttonContainerBox.y + 1,
      buttonContainerBox.width - 2,
      buttonContainerBox.height - 2
    ).attr({
      opacity: 0, // Start transparent
    });

    // Step 2: Animate fade-in
    deleteButton.animate({ opacity: 1 }, 300, 'easeIn');
    deleteButton.node.setAttribute("id", `${type}_${label}_delete`);


    // deleteButton.node.setAttribute(
    //   "style",
    //   "filter: grayscale(100%) brightness(85%) contrast(100%); cursor: pointer;"
    // );
    deleteButton.toFront();
    deleteButton.hide();

    deleteButton.mouseover(() => {
      deleteButton.node.setAttribute(
        "style",
        "filter: invert(27%) sepia(93%) saturate(7492%) hue-rotate(357deg) brightness(70%) contrast(120%); cursor: pointer;"
      );
    });
    deleteButton.mouseout(() => {
      deleteButton.node.setAttribute(
        "style",
        "filter: grayscale(100%) brightness(85%) contrast(100%); cursor: pointer;"
      );
    });

    const showDelete = () => {
      buttonContainer.show()
      deleteButton.show()
    };
    const hideDelete = () => {
      buttonContainer.hide()
      deleteButton.hide()
    };

    const hoverElement = [labelRectangle, labelText, deleteWrapper, buttonContainer, deleteButton]

    hoverElement.forEach((elem) => {
      elem.mouseover(showDelete);
      elem.mouseout(hideDelete);
    })

    deleteButton?.click(() => {
      if(type === "event"){
        const event = this.events?.find(item => item?._id === id);
        this.handleDeleteItem({id, type: "event", item: event, parent});
      } else if(type === "nested_transaction") {
        const transactionData = this.transactions.find(item => item._id  === id);
        if(transactionData !== undefined){
          this.handleDeleteItem({id, type: transactionData.type, name:transactionData.name, item: transactionData, parent});
        }
      } else if(type === "invoked_transaction"){
        const transactionData = this.transactions.find(item => item._id  === id);
        this.handleDeleteItem({id, type: transactionData?.type, name: transactionData.name, uuid,  item: transactionData, parent});
      }
    })

    return { deleteButton, buttonContainer };
  }

  /**
   * Draws a rectangular handler box on the Raphael paper.
   *
   * @param {Object} options - Configuration options.
   * @param {string} options.type - Type of handler ('onrecv' or 'onsend').
   * @param {string|number} options.nodeId - ID of the node to attach the handler.
   * @param {number} options.midY - Vertical center position for the handler box.
   * @returns {RaphaelElement|null} - The drawn handler rectangle or null if drawing fails.
   */
  renderOnsendOnrecvHandlerBox({id, type, nodeId, midY, group }) {
    const eventData = this.events?.find(item => item?._id === id);
    const node = this.nodeManager.getNode(nodeId);
    if (!node) {
      console.warn(`Node not found for nodeId: ${nodeId}`);
      return null;
    }

    const { x: midX } = node;
    const { width, height, onrecvColor, onsendColor, onsendColorMouseOver, onrecvColorMouseOver } = this.handlerBoxConfig || {};

    if (!midX || !width || !height) {
      console.error("Handler box configuration is incomplete.");
      return null;
    }

    const fillColor = type === "onrecv" ? onrecvColor : onsendColor;
    const mouseOverFill = type === "onrecv" ?  onrecvColorMouseOver: onsendColorMouseOver;

    const handler = this.paper.rect(
      midX - width / 2,
      midY - height / 2,
      width,
      height,
      // 10 
    ).attr({
      fill: fillColor,
      stroke: Colors.black,
      "stroke-width": 0,
      rx: 6,
      ry: 6,
      cursor: "pointer",
      //title: `Open ${type === "onsend" ? "onsend" : "onrecv"} handler`
    });


    handler.node.setAttribute("id", `event_${eventData?.name}_${type}HandlerRectangle`);
    handler.node.setAttribute("data-ui-tour-id", `${type}-handler-button`);



    handler.mouseover(() => {
      this.nodeManager?.hidePopUpSet();
      handler.attr({fill: mouseOverFill});
    })

    handler.mouseout(() => {
      handler.attr({fill: fillColor});
    })


    handler?.click(() => {
      const eventData = this.events?.find(item => item?._id === id);

      if(type === "onsend"){
        this.diagramManager?.hightLighSelectedElementInDiagram({id, type: "event"});
        this.handleSelectedItem({ id, type: "event", name: eventData?.name, onsend: true, data: eventData});
      }else{
        this.diagramManager?.hightLighSelectedElementInDiagram({id, type: "event"});
        this.handleSelectedItem({ id, type: "event", name: eventData?.name, onrecv: true, data: eventData});
      }
    })

    const styledTooltip = this.diagramManager?.styledTooltip;

    handler.mouseover(() => {
      styledTooltip.innerText = `Open ${type === "onsend" ? "onsend" : "onrecv"} handler`;
      styledTooltip.style.fontSize = "0.8rem";
      styledTooltip.style.fontWeight = "400";
      styledTooltip.style.display = "block";
    })
    handler.mouseout(() => {
      styledTooltip.style.display = "none";
    });
    handler.mousemove((e) => {
      const tooltipOffsetY = 14;
      styledTooltip.style.left = `${e.clientX}px`;
      styledTooltip.style.top = `${e.clientY - tooltipOffsetY - 30}px`; // adjust Y to account for height + arrow
    });
    

    group.push(handler);

    return handler;
  }

  // === Render Methods ===
  renderEventArrowPath({lineStart, lineEnd, y, eventData, srcData, dstData}) {
    const eventArrowPath = this.paper.path(`M${lineStart},${y} L${lineEnd},${y}`).attr({
      stroke: Colors.dataflow.arrowStroke,
      "stroke-width": 2.5,
      "stroke-dasharray": "-",
      "arrow-end": "block-wide-filled",
    });

    eventArrowPath.node.setAttribute("id", `event_${eventData?.name}_path`);
    eventArrowPath.node.setAttribute("data-src", `${srcData?.name}`);
    eventArrowPath.node.setAttribute("data-dst", `${dstData?.name}`);

    eventArrowPath.node.setAttribute("data-ui-tour-id", `event-arrow`);


    eventArrowPath?.mouseover(() => {
      this.nodeManager?.hidePopUpSet();
    })

      return eventArrowPath;
  }

  // To render alert icon for missing messages
  renderEventConfigAlert({id, paper, rect, group, svgUrl, iconSize = 12, padding = 2}) {
    const eventData = this.events?.find(item => item?._id === id);
   
    const bbox = rect.getBBox();
  
    const icon = paper.image(
      svgUrl,
      bbox.x + bbox.width - iconSize - padding,
      bbox.y + padding,
      iconSize,
      iconSize
    ).attr({
      cursor: "pointer"
    });

    group.push(icon);

    const styledTooltip = this.diagramManager?.styledTooltip;
    const tooltipText = "No event type configured"
    icon.mouseover(() => {
      styledTooltip.innerText = tooltipText;
      styledTooltip.style.display = "block";
    });
    icon.mouseout(() => {
      styledTooltip.style.display = "none";
    });
    icon.mousemove((e) => {
      const tooltipOffsetY = 14;
      styledTooltip.style.left = `${e.clientX}px`;
      styledTooltip.style.top = `${e.clientY - tooltipOffsetY - 30}px`; // adjust Y to account for height + arrow
    });


    // Attach click handler to label box
    icon.click(() => {
      this.diagramManager?.hightLighSelectedElementInDiagram({id, type: "event"});
      this.handleSelectedItem({ id, type: "event", name: eventData?.name, data: eventData});
    });
  
    return icon;
  }

  //  To render the event in the diagram
  renderEvent({eventId, fromId, toId, label, onsend=false, onrecv=false, yPosition=false, pushCreateIcon=true, newEvent=false, normalDraw, onExpand = false, parentId=null }) {
   
    const eventData = this.events?.find(item => item?._id === eventId);
    const srcData = this.clusterlets?.find(item => item?._id === fromId);
    const dstData = this.clusterlets?.find(item => item?._id === toId);

    const group = this.paper.set();
    const fromNode = this.nodeManager.getNode(fromId);
    const toNode = this.nodeManager.getNode(toId);
    if (!fromNode || !toNode) return;

    let { x: x1 } = fromNode;
    let { x: x2 } = toNode;

    let lineStart = x1
    let lineEnd = x2
    if(onrecv){
      if(lineStart > lineEnd){
        lineEnd = lineEnd + this.handlerBoxConfig.width / 2;
      }else{
        lineEnd = lineEnd - this.handlerBoxConfig.width / 2;
      }
    }

    const y = yPosition ? yPosition : (
      this.nodeManager.baseLineY +
      this.nodeManager.plusOffsetY +
      this.nodeManager.level * this.nodeManager.plusShiftStep
    )

    const eventArrowPath = this.renderEventArrowPath({lineStart, lineEnd, y, eventData, srcData, dstData});
    group.push(eventArrowPath);

    // Drag + label
    const midX = (x1 + x2) / 2;
    const midY = y;

    const pathLength = Math.abs(x2 - x1);
    const showFullText = pathLength > 400;


    const {labelRectangle, labelText} = this.renderEventLabel(eventId, midX, midY, label, group,showFullText, pathLength, parentId != null ? parentId : this.selectedTransaction._id);
    const rectBBox = labelRectangle.getBBox();

    const dragX = showFullText ?  rectBBox.x - 30 : midX - this.labelBoxConfig.width / 2 - this.dragBoxConfig.width - this.dragBoxConfig.spacing -12 + 15;
    const dragY = midY - this.dragBoxConfig.height / 2;
    const {verticalDragHandler} = this.renderVerticalDragHandle({x: dragX, y: dragY, group, elementId: eventId, elementType: "event", data: eventData});
    group.push(verticalDragHandler);

    // Render the message missing alert in the label box
    let configAlertIcon = null;
    if(eventData?.message === undefined || eventData?.message === null || eventData?.message === ""){
      configAlertIcon = this.renderEventConfigAlert({id: eventId,paper: this.paper, rect: labelRectangle, svgUrl: this.icons?.alert, group})
    }


    const { deleteButton, buttonContainer, messageButton, messageSchemaButtonContainer }  = this.renderButtons({id: eventId, midX, midY, labelRectangle, labelText, type:"event", parent: parentId, label, isMessageExist: !(eventData?.message === undefined || eventData?.message === null || eventData?.message === "")});
    group.push(deleteButton);
    group.push(buttonContainer);
    if(messageButton != undefined ) group.push(messageButton);
    // To render handlers
    let onsendHandlerBox = null;
    let onrecvHandlerBox = null;
    if(onsend){
      onsendHandlerBox = this.renderOnsendOnrecvHandlerBox({id: eventId, eventData, type: "onsend", nodeId: fromId, midY, group});
    }
    if(onrecv){
      onrecvHandlerBox = this.renderOnsendOnrecvHandlerBox({id: eventId, eventData, type: "onrecv", nodeId: toId, midY, group });
    }

    // To render horizontal drag handler in the event
    const nodesCount = this.selectedTransaction?.clusterlets?.length
    const isHorizontalDragNeeded = nodesCount > 2 ? true : false;
    let horizontalDragHandleElements = null;
    if(isHorizontalDragNeeded){
      horizontalDragHandleElements =  this.renderEventHorizontalDragHandler({id:eventId, midY, x1, x2, onrecv, target: toId})
    }

    // To render the condition attribute in the event arrow
    let conditionAttributeIcon = null;
    let conditionAttributeLabelBox = null;
    let conditionATtributeLabel = null;
    if(eventData?.condition && eventData?.condition !== ""){
      const showAttributeLabel = false;
      const attributeElements = this.renderConditionAttributeForEvent({id: eventId, src: fromId, dst: toId, y, showAttributeLabel, group, onrecv})
      conditionAttributeIcon = attributeElements.conditionAttributeIcon;
      conditionAttributeLabelBox = attributeElements.conditionAttributeLabelBox;
      conditionATtributeLabel = attributeElements.conditionATtributeLabel;
    }


    if(pushCreateIcon) this.nodeManager.incrementLevelAndUpdatePlusIcons();

    const drawnItem =  {
      name : label,
      id: eventId,
      type: "event",
      parentId : parentId ,
      source: fromId,
      target: toId,
      group,
      onsendHandlerBox,
      onrecvHandlerBox,
      verticalDragHandler,
      labelRectangle,
      labelText,
      eventArrowPath,
      lineStart,
      lineEnd,
      deleteButton: [ deleteButton, buttonContainer ],
      y,
      highlightElement: labelRectangle,
      configAlertIcon,
      conditionAttributeIcon,
      conditionAttributeLabelBox,
      conditionATtributeLabel,
      messageButton : [ messageButton, messageSchemaButtonContainer]
    };
    if(isHorizontalDragNeeded && horizontalDragHandleElements){
      group.push(horizontalDragHandleElements?.dragHandlerWrapper, horizontalDragHandleElements?.dragHandler);
      drawnItem.horizontalDragHandler = horizontalDragHandleElements?.dragHandler;
    }


    this.draggableItems.push({
      id: eventId,
      type: "event",
      group: group,
      y: y,
      height: this.verticalDragSpacing, // Approximate height for reordering calculations
      //Store references to sub-elements for easier manipulation during re-positioning
      elements: {
        eventArrowPath,
        labelRectangle,
        labelText,
        verticalDragHandler,
        onsendHandlerBox,
        onrecvHandlerBox,
      }
    });
    this.sortDraggableItems();


    this.eventArrows[eventId] = drawnItem;
    this.transactionElemnts[eventId] = drawnItem;


    // Bind the horizontal drag functionality to event
    if(isHorizontalDragNeeded){
      this.dragAndExtendEvent({event: drawnItem} );
    }

    this.drawnEvents.push({ yPosition : y, id: eventId, path :  eventArrowPath, label});
    return group;
  }




  updateElementName(name, id, elements){

    let updatedElements = [...elements ];

    updatedElements.map(el => {
      if(el._id == id){
        el.name = name
      }
    })

    return updatedElements;

  }

  updatePaperData(){
    this.nodeManager.lastDrawnElement = null;
    this.diagramManager.clearAllElements();
    this.diagramManager.init();
  }

  onUpdateElementName(name, id, src, dst, order, parentId, type ){
    if(type === "event"){
      this.nodeManager.triggerCreateEventAPI(id, src, dst, name, order, parentId);
      let updatedEvents = this.updateElementName(name, id, this.events);
      this.diagramManager.updateTransactionData({ events : updatedEvents})
    }
    else if(type === "transaction"){
      this.nodeManager.triggerCreateTransactionAPI(id, name, order, parentId);
      let updatedTxs = this.updateElementName(name, id, this.transactions);
      this.diagramManager.updateTransactionData({ transactions : updatedTxs})
    }

  }



  addInputToElement() {
    if (this.nodeManager.lastDrawnElement != null) {

      let lastDrawnElement = null;

      if(this.nodeManager.lastDrawnElement.type === "event"){
        lastDrawnElement = this.eventArrows[this.nodeManager.lastDrawnElement.id];
      }
      else{
        lastDrawnElement = this.childTransactions[this.nodeManager.lastDrawnElement.id];
      }

      let elId = this.nodeManager.lastDrawnElement.id;

      if (lastDrawnElement === undefined || lastDrawnElement === null) return;

      if(Array.isArray(lastDrawnElement.deleteButton)){
        lastDrawnElement.deleteButton.forEach(el => el.remove())
      }

      if (this.nodeManager.lastDrawnElement.type === "event") {
        lastDrawnElement.labelText.hide();
        this.makeLabelEditableInline({
          labelRectangle: lastDrawnElement.labelRectangle,
          labelText: lastDrawnElement.labelText,
          initialText: lastDrawnElement.name,
          onLabelUpdate: (newLabel) => {
            lastDrawnElement.labelText.attr("text", this.truncateLabel(newLabel) || lastDrawnElement.name);
            lastDrawnElement.labelText.show(); // Show once done

            let order = this.nodeManager.lastDrawnElement?.order;
            let pId = this.nodeManager.lastDrawnElement?.parentId;
            let evSrc = this.nodeManager.lastDrawnElement?.src;
            let evDst = this.nodeManager.lastDrawnElement?.dst;

            this.nodeManager.lastDrawnElement = null;
            this.diagramManager.focusElement = {type : "event", id : elId }

            const eventIndex = this.drawnEvents.findIndex(ev => ev.id === elId);
            if (eventIndex !== -1) this.drawnEvents[eventIndex].label = newLabel;
            this.onUpdateElementName(newLabel, elId, evSrc, evDst, order, pId, "event");
            this.updatePaperData();
          },
          type: "event"

        });


      } else if (this.nodeManager.lastDrawnElement.type == "transaction") {

        lastDrawnElement.transactionLabelText.hide();

        this.makeLabelEditableInline({
          labelRectangle: lastDrawnElement.transactionLabelBox,
          labelText: lastDrawnElement.transactionLabelText,
          initialText: lastDrawnElement.name,
          onLabelUpdate: (newLabel) => {
            lastDrawnElement.transactionLabelText.attr("text", this.truncateLabel(newLabel, "transaction") || lastDrawnElement.name);
            lastDrawnElement.transactionLabelText.show(); // Show once done

            let order = this.nodeManager.lastDrawnElement?.order;
            let pId = this.nodeManager.lastDrawnElement?.parentId;
            let evSrc = this.nodeManager.lastDrawnElement?.src;
            let evDst = this.nodeManager.lastDrawnElement?.dst;

            this.nodeManager.lastDrawnElement = null;
            this.diagramManager.focusElement = {type : "transaction", id : elId }


            const txIndex = this.drawnChildTransactions.findIndex(tx => tx.id === elId);
            if (txIndex !== -1) this.drawnChildTransactions[txIndex].label = newLabel;
            this.onUpdateElementName(newLabel, elId, evSrc, evDst, order, pId, "transaction");
            this.updatePaperData();
          },
          type: "transaction"
        });

      }

    }
  }

  cancelActiveInlineEditor() {
    const el = document.getElementById("custom_name_field");
    if (!el) return;
  
    if (el.__onBlur) el.removeEventListener("blur", el.__onBlur);
    if (el.__onKeydown) el.removeEventListener("keydown", el.__onKeydown);
  
    try {
      el.remove(); // ✅ remove only the input
    } catch (_) {}
  
    const container = document.getElementById("transaction_container");
    if (container) container.style.overflow = "auto";
  }

  makeLabelEditableInline({ labelRectangle, labelText, initialText, onLabelUpdate, type = "event" }) {
    
    this.cancelActiveInlineEditor();

    if (!labelRectangle || !labelRectangle.node || typeof labelRectangle.node.getScreenCTM !== "function") {
      return;
    }

    const bbox = labelRectangle.getBBox();
    const rectNode = labelRectangle.node;

    if (!rectNode || typeof rectNode.getScreenCTM !== "function") return;
    const ctm = rectNode.getScreenCTM();
    const screenX = ctm.e + bbox.x;
    const screenY = ctm.f + bbox.y;

    const container = document.getElementById("transaction_container");
    const containerRect = container.getBoundingClientRect();
    const canvasRect = this.paper.canvas.getBoundingClientRect();

    const scrollLeft = container.scrollLeft;
    const scrollTop = container.scrollTop;

    const input = document.createElement("input");
    input.type = "text";
    input.value = initialText;
    input.id = "custom_name_field"

    input.style.position = "absolute";
    input.style.left = `${screenX}px`;
    input.style.top = `${screenY}px`;


    input.style.width = `${bbox.width}px`;
    input.style.height = `${bbox.height}px`;
    input.style.fontSize = "12px";
    input.style.textAlign = "center" ;
    input.style.border = "0.5px solid red !important";
    input.style.padding = "0";
    input.style.margin = "0";
    input.style.background = "white";
    input.style.zIndex = "999";
    // // input.style.outline = "0.5px solid yellow"

    container.style.overflow = "hidden";


    document.body.appendChild(input);
    input.focus();
    input.select();

    input.addEventListener("input", () => {
      input.value = input.value.replace(/[^\w]/g, ""); // \w = [a-zA-Z0-9_]
    });

    const finalizeEdit = () => {
      const newText = input.value.trim();

      if (!newText) {
        input.style.border = "1px solid red";
        input.focus();
        return;
      }
      input.remove();
      container.style.overflow = "auto";
      // onLabelUpdate?.(newText);
      if (typeof onLabelUpdate === "function") {
        try {
          onLabelUpdate(newText);
        } catch (err) {
          console.warn("onLabelUpdate failed, element may no longer exist", err);
        }
      }
    };

    input.addEventListener("blur", finalizeEdit);
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        input.blur();
      }
    });
  }


  renderChildTransactionLabel({id, uuid, labelX, y, label, group, isInvoked=false, parent, showFullText}) {
    const transaction = this.transactions?.find(item => item?._id === id);

    const padding = 5;
    let myself = this;

    let labels = this.splitLabel(label)

   
    const transactionLabelText = this.paper.text(
      labelX + padding,
      y - ((labels.length - 1) * 10) / 2
    ).attr({
      "font-size": this.labelBoxConfig.fontSize,
      "text-anchor": 'start',
      // "dominant-baseline": "left",
      fill: Colors.black,
      cursor: 'pointer',
      //title:  transaction?.name || label

    });

    this.setMultilineText(transactionLabelText, labels)

    const textBBox = transactionLabelText.getBBox();
    const boxWidth =  textBBox.width + padding * 2;

    const transactionLabelBox = this.paper.rect(
      labelX,
      y - this.labelBoxConfig.height / 2,
      // this.labelBoxConfig.width,
      boxWidth,
      this.labelBoxConfig.height,
      4
    ).attr({
      fill: Colors.white,
      stroke: Colors.black,
      "stroke-width": 0,
      cursor: 'pointer',
      //title: transaction?.name || label
    });

    transactionLabelBox.node.setAttribute("id", `${isInvoked ? "invoked" : "child"}_${transaction?.name}_labelBox`);
    transactionLabelText.node.setAttribute("id", `${isInvoked ? "invoked" : "child"}_${transaction?.name}_labelText`);

    const itemType = isInvoked ? "invoked_transaction" : "nested_transaction"

    // Hightlight while mouse over
    transactionLabelBox.mouseover(() => {
      this.diagramManager?.hightlightHoverItem({id: itemType==="invoked_transaction" ? uuid : id, type: itemType});
    })
    transactionLabelText.mouseover(() => {
      this.nodeManager?.hidePopUpSet();
      this.diagramManager?.hightlightHoverItem({id: itemType==="invoked_transaction" ? uuid : id, type: itemType});
    })

    transactionLabelBox.mouseout(() => {
      this.diagramManager?.removeHoveringHighlight();
    })


    var labelGroup = this.paper.set();
    labelGroup.push(transactionLabelText, transactionLabelBox);

    let clickTimer;
    const clickDelay = 250; // adjust to taste
    
    labelGroup.click(function (e) {
      if (clickTimer) {
        // Second click within delay → double-click detected
        clearTimeout(clickTimer);
        clickTimer = null;
        onDoubleClick.call(this, e);
      } else {
        // First click → wait to see if another comes
        let self = this;
        clickTimer = setTimeout(function () {
          onSingleClick.call(self, e);
          clickTimer = null;
        }, clickDelay);
      }
    });

    function onSingleClick(e) {
      myself.diagramManager?.hightLighSelectedElementInDiagram({id: itemType==="invoked_transaction" ? uuid : id, type: itemType});
      myself.handleSelectedItem({
        id,
        type: itemType,
        name: transaction?.name || label,
        uuid,
        parent,
        data: transaction
      });
    }

    function onDoubleClick(e) {
      myself.makeLabelEditableInline({
        labelRectangle: transactionLabelBox,
        labelText: transactionLabelText,
        initialText: transaction?.name,
        onLabelUpdate: (newLabel) => {
          transactionLabelText.attr("text", myself.truncateLabel(newLabel, "transaction") || transaction.name)
          const txIndex = myself.drawnChildTransactions.findIndex(tx => tx.id === id);
          if (txIndex !== -1) myself.drawnChildTransactions[txIndex].label = newLabel;
          myself.triggerUpdateElementNameApi(id,newLabel,"transaction")
          let updatedTxs = myself.updateElementName(newLabel, id, myself.transactions);
          myself.diagramManager.updateTransactionData({ transactions : updatedTxs})
          myself.updatePaperData();
        },
        type: "transaction"

      });
    }

    group.push(transactionLabelBox, transactionLabelText);
    transactionLabelText.toFront();

    return { transactionLabelBox, transactionLabelText, boxWidth };
  }

  // Render attribute icon
  renderAttributeIcon({x, y, type, group, typeLabel, value, size, showType=true, icon_id="attribute_icon"}) {
    
    const iconSize = size || this.attributeConfig?.iconSize;
    const iconSVG = this.icons[type] || null;

    y = y - iconSize / 2; // Center the icon vertically
    
    let icon = null;
    icon = this.paper.image(iconSVG, x, y, iconSize, iconSize).attr({cursor: 'pointer'});

    icon.node.setAttribute("id", icon_id);

    const styledTooltip = this.diagramManager?.styledTooltip;
    let tooltipText = "";
    if(showType){
      tooltipText = type === "oneof" ?  typeLabel : `${typeLabel}: ${value}`;
    }else{
      tooltipText = type === "oneof" ?  typeLabel : value;
    }
    icon.mouseover(() => {
      styledTooltip.innerText = tooltipText;
      styledTooltip.style.display = "block";
    });
    icon.mouseout(() => {
      styledTooltip.style.display = "none";
    });
    icon.mousemove((e) => {
      const tooltipOffsetY = 14;
      styledTooltip.style.left = `${e.clientX}px`;
      styledTooltip.style.top = `${e.clientY - tooltipOffsetY - 30}px`; // adjust Y to account for height + arrow
    });



    group.push(icon);
    return icon;

  }

  // Render attribute label text
  renderAttributeLabel({paper, x, y, group, label, type, label_id="attribute_label"}) {
    const padding = 5;
    const fontSize = 12;

    const labelElement = paper
      .text(x + padding, y, label)
      .attr({
        'font-size': fontSize,
        'text-anchor': 'start',
      });

      labelElement.node.setAttribute("id", label_id);

      group.push(labelElement);
      return labelElement;
  }


  // Render attribute label box
  renderAttributeLabelBox({paper, x, y, width, group}) {

    const height = this.attributeConfig?.labelBoxHeight || 22;
    const adjustedY = y - height/2;

    const labelBox = paper.rect(
      x,
      adjustedY,
      width,
      height,
      4
    ).attr({
      "fill": Colors.white,
      "stroke": Colors.black,
      "stroke-width": 0,
      "cursor": 'pointer',
    });
    group.push(labelBox);

    return labelBox;
    
  }

  // Render condition for event
  renderConditionAttributeForEvent({id, src, dst, y, group, onrecv}) {
    const eventData = this.events?.find(item => item?._id === id);
    if(eventData === null || eventData === undefined) return null;
    
    const condition = eventData?.condition;

    const srcNode = this.nodeManager.getNode(src);
    const dstNode = this.nodeManager.getNode(dst); 
    const isEventToRight = srcNode?.x < dstNode?.x ? true : false;
    const showConditionLabel = isEventToRight ? dstNode.x - srcNode?.x > 400 : srcNode?.x - dstNode?.x > 400

    const icon_element_id = `event_${eventData?.name}_condition_icon`
    const label_element_id = `event_${eventData?.name}_condition_label`

    let attributeLabel = null; 
    let attributeIcon = null;
    let attributeLabelBox = null;
    if(showConditionLabel){
      const labelWidth = getTextWidth(`Condition`);
      const iconSize  = this.attributeConfig.iconSize;
      const rightOffset = 65;

      if(isEventToRight){ 
        // Render attribute label box
        const labelBoxXPosition = dstNode.x - labelWidth - iconSize - rightOffset;
        const labelBoxYPosition = y;
        const labelBoxWidth = labelWidth + iconSize + 24;
        attributeLabelBox = this.renderAttributeLabelBox({
          paper: this.paper,
          x: labelBoxXPosition, // Adjust as needed
          y: labelBoxYPosition, // Align with info icon
          group,
          width: labelBoxWidth 
        });
        group.push(attributeLabelBox);

        // Render the attribute label 
        const labelXPosition = dstNode?.x - (rightOffset + 10) - labelWidth;
        const labelYPosition = y;
        attributeLabel = this.renderAttributeLabel({
          paper: this.paper,
          x: labelXPosition, 
          y: labelYPosition,
          label: "Condition",
          group,
          label_id: label_element_id
        })
        group.push(attributeLabel);

        // Render the info icon
        const xPosition = dstNode.x - rightOffset; // Adjust as needed
        const yPosition = y; // Adjust as needed 
        attributeIcon = this.renderAttributeIcon({
          x: xPosition, 
          y: yPosition, 
          type: "condition",
          group,
          typeLabel: "Condition",
          value: condition,
          showType: false,
          icon_id: icon_element_id
        })


        

      }else{
          // Render attribute label box
          const leftOffset = 40;
          const labelBoxXPosition = dstNode.x + leftOffset;
          const labelBoxYPosition = y;
          const labelBoxWidth = labelWidth + iconSize + 24;
          attributeLabelBox = this.renderAttributeLabelBox({
            paper: this.paper,
            x: labelBoxXPosition, // Adjust as needed
            y: labelBoxYPosition, // Align with info icon
            group,
            width: labelBoxWidth 
          });
          group.push(attributeLabelBox);

          // Render the attribute label 
          const labelRectBbox = attributeLabelBox.getBBox();
          const labelXPosition = labelRectBbox?.x + 5;
          const labelYPosition = y;
          attributeLabel = this.renderAttributeLabel({
            paper: this.paper,
            x: labelXPosition, 
            y: labelYPosition,
            label: "Condition",
            group,
            label_id: label_element_id
          })
          group.push(attributeLabel);

          // Render the info icon
          const attributeLabelBbox = attributeLabel.getBBox();
          const xPosition = attributeLabelBbox?.x + attributeLabelBbox?.width + 5; // Adjust as needed
          const yPosition = y; // Adjust as needed 
          attributeIcon = this.renderAttributeIcon({
            x: xPosition, 
            y: yPosition, 
            type: "condition",
            group,
            typeLabel: "Condition",
            value: condition,
            showType: false,
            icon_id: icon_element_id
          })


          
      }

    }else{
      let xPosition = dstNode.x; // Adjust as needed
      let yPosition = y; // Adjust as needed 
      if(isEventToRight){
        xPosition = dstNode.x - 60;
      }else{
        xPosition = dstNode.x + 40 ; // Adjust as needed
      }
  
      attributeIcon = this.renderAttributeIcon({
        x: xPosition, 
        y: yPosition, 
        group,
        type: "condition",
        typeLabel: "Condition",
        value: condition,
        icon_id: icon_element_id
      })

    }

    return {
      conditionAttributeIcon: attributeIcon,
      conditionAttributeLabelBox: attributeLabelBox,
      conditionATtributeLabel: attributeLabel,
    }
  } 

  // Render attributes for chld transaction
  renderAttributesForChildTransactions({id, src, dst, y, group, data, showAttributeLabel, invoked=false}){
    const attributeType = data?.oneof ? "oneof" : (data?.loop && data?.loop !== "")  ? "loop" : (data?.condition && data?.condition !== "") ? "condition" : null;
    if(attributeType === null) return;
  
    const dstNode = this.nodeManager.getNode(dst); 
    const label = attributeType === "condition" ? "Condition" : attributeType === "oneof" ? "Oneof" : "Loop"; 
    let attributeValue = "";
    switch (attributeType) {
        case "condition":
            attributeValue = data.condition;
            break;
        case "loop":
            const loopFn = this.utilityFunctions.find(uf => uf._id.toString() === data.loop);
            attributeValue = loopFn ? loopFn.name : "";
            break;
        default:
            attributeValue = "";
    }
    let attributeLabel = null; 
    let attributeIcon = null;
    let infoIcon = null;
    let attributeLabelBox = null;
    const icon_element_id =  `${invoked ? "invoked" : "child"}_${data?.name || ""}_${attributeType}_icon`
    const label_element_id = `${invoked ? "invoked" : "child"}_${data?.name || ""}_${attributeType}_label`
    // console.log({icon_element_id,label_element_id})
    if(showAttributeLabel){
      const labelWidth = getTextWidth(label);
      const iconSize  = this.attributeConfig.iconSize;
      const rightOffset = 40;
  
  
      // Render attribute label box
      const labelBoxXPosition = dstNode.x - labelWidth - iconSize - rightOffset;
      const labelBoxYPosition = y;
      const labelBoxWidth = labelWidth + iconSize + 24;
  
      attributeLabelBox = this.renderAttributeLabelBox({
        paper: this.paper,
        x: labelBoxXPosition, // Adjust as needed
        y: labelBoxYPosition, // Align with info icon
        group,
        width: labelBoxWidth
      });
      group.push(attributeLabelBox);
  
      // Render the info icon
      const xPosition = dstNode.x - rightOffset; // Adjust as needed
      const yPosition = y; // Adjust as needed 
      attributeIcon = this.renderAttributeIcon({
        x: xPosition, 
        y: yPosition, 
        type: attributeType,
        group,
        typeLabel: label,
        value: attributeValue,
        showType: false,
        icon_id: icon_element_id
      })
  
  
      // Render the attribute label 
      const labelXPosition = dstNode?.x - (rightOffset + 10) - labelWidth;
      const labelYPosition = y;
      attributeLabel = this.renderAttributeLabel({
        paper: this.paper,
        x: labelXPosition, 
        y: labelYPosition,
        label,
        group,
        label_id: label_element_id
      })
      group.push(attributeLabel);
  
    }else{
      // const xPosition = (srcNode.x + dstNode.x) / 2;
      const xPosition = dstNode.x - 40; // Adjust as needed
      const yPosition = y; // Adjust as needed 
  
      attributeIcon = this.renderAttributeIcon({
        x: xPosition, 
        y: yPosition, 
        type: attributeType,
        group,
        typeLabel: label,
        value: attributeValue,
        icon_id: icon_element_id
  
      })
  
    }
    if (attributeIcon) {
      attributeIcon.click(() => {
        const loopFn = this.utilityFunctions.find(uf => uf._id.toString() === data.loop);
        if(loopFn) {
          this.setSelectedUtilityFunction(loopFn);
        }
      })
    }
  
    return {
      attributeIcon,
      attributeLabel,
      infoIcon,
      attributeLabelBox
    }
  } 

  

  /**
   * Renders a child transaction between two nodes with UI elements.
   *
   * @param {Object} params
   * @param {string} params.fromId - Starting node ID
   * @param {string} params.toId - Ending node ID
   * @param {string} params.label - Label text
   * @param {string} params.transactionId - Transaction ID
   * @param {string|null} [params.parentId=null] - Parent transaction ID
   * @param {number|boolean} [params.yPosition=false] - Y-coordinate
   * @param {boolean} [params.onExpand=false] - Whether triggered by expand
   * @param {boolean} [params.firstLevelChild=false] - Flag for first-level child
   * @param {Object} params.childrenCount - Counts of child elements (events, transactions)
   * @param {Array} params.children - Child transactions
   * @returns {RaphaelSet|null} - Rendered group or null
   */
  renderTransaction({fromId, toId, label, transactionId, parentId=null, yPosition=false, onExpand = false, firstLevelChild=false, childrenCount, children, isExpanded=false}) {
    const transaction = this.transactions?.find(item => item?._id === transactionId);

    const group = this.paper.set();
    const fromNode = this.nodeManager.getNode(fromId);
    const toNode = this.nodeManager.getNode(toId);
    if (!fromNode || !toNode) return;

    const { x: x1 } = fromNode;
    const { x: x2 } = toNode;

    const y = yPosition ? yPosition : (
      this.nodeManager.baseLineY +
      this.nodeManager.plusOffsetY +
      this.nodeManager.level * this.nodeManager.plusShiftStep
    )

    const transactionPath = this.paper.path(`M${x1},${y} L${x2},${y}`).attr({
      stroke: Colors.dataflow.nestedTxPath,
      "stroke-width": 3,
    });
    transactionPath.node.setAttribute("id", `child_${transaction?.name}_path`);
    
    group.push(transactionPath);
    
    // Add the  data-ui-tour to the arrow if the child is not in the expanded state, otherwise wrappwer rectangle will be highlighted
    if(isExpanded === false){
      transactionPath.node.setAttribute("data-ui-tour-id", `child_transaction`);
    }
    
    // Draw arrow triangles
    const baseHeight = 6, apexLength = 18;
    const startShape = this.paper.path(
      `M${x2},${y - baseHeight} L${x2},${y + baseHeight} L${x2 - apexLength},${y} Z`
    ).attr({ fill: Colors.dataflow.nestedTxPath, stroke: "none" });

    const endShape = this.paper.path(
      `M${x1},${y - baseHeight} L${x1},${y + baseHeight} L${x1 + apexLength},${y} Z`
    ).attr({ fill: Colors.dataflow.nestedTxPath, stroke: "none" });

    group.push(startShape, endShape);


    // Drag and label box to the right of x1
    const labelGroupStartX = x1 + 25;
    const dragY = y - this.dragBoxConfig.height / 2;
    const {verticalDragHandler, labelX} = this.renderVerticalDragHandle( {x: labelGroupStartX, y: dragY, group, elementType: "child", data: transaction});


    const expandIconSize = 13;

    const pathLength = Math.abs(x2 - x1);
    const showFullText = pathLength > 400;

    const {transactionLabelBox, transactionLabelText, boxWidth } = this.renderChildTransactionLabel( {id: transactionId, labelX : labelX + 25, y, label, group, parent: parentId, showFullText});


    const infoBoxGap = 10;
    const boxHeight = this.labelBoxConfig.height;


    let nextBoxX = labelX + boxWidth + 25 + infoBoxGap;

    if(childrenCount.eventsCount > 0){
      const eventText = showFullText ? `${childrenCount.eventsCount} ${childrenCount.eventsCount > 1 ? "Events" : "Event"}` : `${childrenCount.eventsCount}`;
      const eventBox = this.drawInfoBox({
        x: nextBoxX,
        y,
        text: eventText,
        isLarge: showFullText,
        paper: this.paper,
        boxHeight,
        group,
        title: childrenCount.eventsCount > 1 ? `${childrenCount.eventsCount} Events` : `${childrenCount.eventsCount} Event`
      });

      nextBoxX += eventBox.getBBox().width + infoBoxGap;

    }

    if((childrenCount.nestedTxCount +  childrenCount.invokedTxCount )> 0){
      const txnText = showFullText ? `${childrenCount.nestedTxCount +  childrenCount.invokedTxCount} ${(childrenCount.nestedTxCount +  childrenCount.invokedTxCount) > 1 ? "Transactions" : "Transaction"}` : `${childrenCount.nestedTxCount +  childrenCount.invokedTxCount}`;
      const txnBox = this.drawInfoBox({
        x: nextBoxX,
        y,
        text: txnText,
        isLarge: showFullText,
        paper: this.paper,
        boxHeight,
        group,
        title: (childrenCount.nestedTxCount +  childrenCount.invokedTxCount) > 1 ? `${(childrenCount.nestedTxCount +  childrenCount.invokedTxCount)} Transactions` : `${(childrenCount.nestedTxCount +  childrenCount.invokedTxCount)} Transaction`
      });
      group.push(txnBox)

    }


    const deleteButtonMidX = labelGroupStartX + (this.labelBoxConfig.width / 2) + expandIconSize - this.deleteButtonConfig?.width;
    const { deleteButton, buttonContainer, messageButton, messageSchemaButtonContainer }  = this.renderButtons({id: transactionId, midX: deleteButtonMidX, midY:y, labelRectangle:transactionLabelBox, labelText:transactionLabelText, type:"nested_transaction", parent: parentId, label});
    group.push(deleteButton);
    group.push(buttonContainer);
    if(messageButton != undefined ) group.push(messageButton);
    // Toggle arrow icon (down if collapsed, up if expanded)

    const arrowX = labelX + 5; // Padding inside box
    const arrowY = y;

    const expandCollapseIcon = this.renderExpandCollapseButton({id: transactionId, x: arrowX, y: arrowY, size: expandIconSize, transactionLabelBox, group, childName: transaction?.name})
    group.push(expandCollapseIcon);

    // Render condition or loop or oneof in diagram
    this.renderAttributesForChildTransactions({id: transactionId, src: fromId, dst: toId, group, y: arrowY, data: transaction, showAttributeLabel: pathLength > 400});

    this.nodeManager.incrementLevelAndUpdatePlusIcons();


    const drawnItem = { 
      name : label, 
      id: transactionId,type: "child_transaction", 
      parentId : parentId, 
      transactionPath, 
      group , 
      startShape, 
      endShape, 
      verticalDragHandler,
      transactionLabelBox,
      transactionLabelText,
      expandButton: expandCollapseIcon,
      deleteButton: [deleteButton, buttonContainer],
      y,
      source: fromId,
      target: toId,
      highlightElement: transactionLabelBox,
      firstLevelChild,
      children,
      messageButton : [ messageButton, messageSchemaButtonContainer]

    }
    drawnItem.apexLength = apexLength;
    drawnItem.baseHeight = baseHeight;
    drawnItem.startX = x2;
    drawnItem.endX = x1;

    this.childTransactions[transactionId] = drawnItem;
    this.transactionElemnts[transactionId] = drawnItem;

    this.draggableItems.push({
      id: transactionId,
      type: "child_transaction",
      group: group,
      y: y,
      height: this.verticalDragSpacing,
      elements: {
        eventArrowPath : transactionPath,
        labelRectangle: transactionLabelBox,
        labelText : transactionLabelText,
        verticalDragHandler,
        startShape,
        endShape,
        expandButton: expandCollapseIcon
      }
    });
    this.drawnChildTransactions.push({ yPosition : y, id:transactionId, path : transactionPath, label });

    return group;

  }

  drawInfoBox({ x, y, text, isLarge = false, paper, boxHeight = 30, group, title }) {

    const padding = 5;
    const fontSize = 12;

    const textElement = paper.text(x + padding, y, text).attr({
      'font-size': fontSize,
      'text-anchor': 'start',
      //'title' : title
    });

    const textBBox = textElement.getBBox();
    const boxWidth =  textBBox.width + padding * 2;

    const rect = paper.rect(x, y - boxHeight / 2, boxWidth, boxHeight, 4).attr({
      fill: Colors.white,
      stroke: "#none",
      title : title
    }).insertBefore(textElement);

    group.push(textElement,rect)

    const set = paper.set();
    set.push(rect, textElement);

    const styledTooltip = this.diagramManager?.styledTooltip;

    set.mouseover(() => {
      styledTooltip.innerText = title;
      styledTooltip.style.fontSize = "0.8rem";
      styledTooltip.style.fontWeight = "400";
      styledTooltip.style.display = "block";
    })
    set.mouseout(() => {
      styledTooltip.style.display = "none";
    });
    set.mousemove((e) => {
      const tooltipOffsetY = 14;
      styledTooltip.style.left = `${e.clientX}px`;
      styledTooltip.style.top = `${e.clientY - tooltipOffsetY - 30}px`; // adjust Y to account for height + arrow
    });


    return set;
  }

  renderExpandCollapseButton({id, x, y, size, transactionLabelBox, group, childName}){

    const isExpanded = this.expandedChildTransactions[id] ? true : false;


    const expandCollapseButton = this.paper.image(
      isExpanded ? this.icons.expandIcon : this.icons.collapseIcon,
      x,
      y - size / 2,
      size,
      size
    ).attr({ cursor: "pointer", title : `Click to ${isExpanded ? "collapse" : "expand"}` });

    expandCollapseButton.node.setAttribute("id", `child_${childName}_${isExpanded ? "collapse" : "expand"}`);
    expandCollapseButton.node.setAttribute("data-ui-tour-id", `child_transaction-${isExpanded ? "collapse" : "expand"}`);


    const bbox = expandCollapseButton.getBBox();

    const wrapperRect = this.paper.rect(bbox.x -5, bbox.y -5, bbox.width +10, bbox.height+10)
      .attr({
        fill: Colors.white,
         stroke: "#none",  // so it's clickable but not visible
        cursor: "pointer"
      }).insertBefore(expandCollapseButton);

    wrapperRect.node.setAttribute("id", `child_${childName}_expandWrapper`)

    expandCollapseButton.data('transactionId', id); // Store transaction ID with the arrow
    expandCollapseButton.data('isExpanded', false); // Track expansion state
    expandCollapseButton.data('isExpandButton', true);

    const newSet  = this.paper.set().push(expandCollapseButton,wrapperRect);


    for (const el of newSet.items) {
      el.click(async () => {
        try {

          // Prevent multiple clicks while processing
          if( this.disableExpandButtonClick) return;

          // Disable further clicks until the operation is complete
          this.disableExpandButtonClick = false;

          if (this.expandedChildTransactions[id]) {
            this.expandedChildTransactions[id] = false;
            await this.handleChildtransactionCollapse(id);

            this.lastExpandedChild = id;
            this.diagramManager?.clearAllElements();
            this.diagramManager?.init();
          } else {
            this.expandedChildTransactions[id] = true;
            this.lastExpandedChild = id;
            this.diagramManager?.clearAllElements();
            this.diagramManager?.init();
          }

          this.disableExpandButtonClick = false;
        } catch (err) {
          console.error("Error during expand/collapse:", err);
        }
      });
    }



    // To reset the fill color of label when the mouse is moving out
    newSet.forEach(el => {
      el.mouseover(() => {
        this.diagramManager?.hightlightHoverItem({id, type: "nested_transaction"});
      })
    })

    newSet.forEach(el => {
      el?.mouseout(() => {
        this.diagramManager?.removeHoveringHighlight();
      })
    })

    group.push(wrapperRect)

    return expandCollapseButton
  }


  renderInvokedTransaction({fromId, toId, label, transactionId, parentId=null, uuid}) {
    const transaction = this.transactions?.find(item => item?._id === transactionId);
    const parentTransaction = this.transactions?.find(item => item?._id === parentId);
    const invokedData =  parentTransaction?.invokedTransactions?.find(item => item?.uuid === uuid);
    const srcData  = this.clusterlets?.find(item => item?._id === fromId);
    const dstData  = this.clusterlets?.find(item => item?._id === toId);


    const group = this.paper.set();
    const fromNode = this.nodeManager.getNode(fromId);
    const toNode = this.nodeManager.getNode(toId);
    if (!fromNode || !toNode) return;

    const { x: x1 } = fromNode;
    const { x: x2 } = toNode;
    const y =
      this.nodeManager.baseLineY +
      this.nodeManager.plusOffsetY +
      this.nodeManager.level * this.nodeManager.plusShiftStep;

    // Main path
    const transactionPath = this.paper.path(`M${x1},${y} L${x2},${y}`).attr({
      stroke: Colors.dataflow.invokedTxPath,
      "stroke-width": 3,
    });
    transactionPath.node.setAttribute("id", `invoked_${transaction?.name}_path`);
    transactionPath.node.setAttribute("data-ui-tour-id", `invoked_transaction`);
    transactionPath.node.setAttribute("data-src", srcData?.name);
    transactionPath.node.setAttribute("data-dst", dstData?.name);

    group.push(transactionPath);

    // Arrow at destination
    // const baseHeight = 6, apexLength = 18;
    // const arrowHead = this.paper.path(
    //   `M${x2},${y - baseHeight} L${x2},${y + baseHeight} L${x2 - apexLength},${y} Z`
    // ).attr({ fill: "#0077cc", stroke: "none" });
    // group.push(arrowHead);

    // Filled circle at start
    const startCircle = this.paper.circle(x1, y, 6).attr({
      fill: Colors.dataflow.invokedTxPath,
      stroke: "none"
    });

    const endCircle = this.paper.circle(x2, y, 6).attr({
      fill: Colors.dataflow.invokedTxPath,
      stroke: "none"
    });

    group.push(startCircle, endCircle);

    // Drag handle and label
    const labelGroupStartX = x1 + 25;
    const dragY = y - this.dragBoxConfig.height / 2;
    const { verticalDragHandler, labelX } = this.renderVerticalDragHandle({x: labelGroupStartX, y: dragY, group, elementType: "invoked", data: transaction});


    const { transactionLabelBox, transactionLabelText } = this.renderChildTransactionLabel( {id: transactionId, uuid, labelX, y, label, group, isInvoked:true, parent: parentId, data: transaction});


    const deleteButtonMidX = labelGroupStartX + (this.labelBoxConfig.width / 2) +  40 - this.deleteButtonConfig?.width;
    const { deleteButton, buttonContainer, messageButton, messageSchemaButtonContainer } = this.renderButtons({id: transactionId, midX: deleteButtonMidX, midY: y, labelRectangle: transactionLabelBox, labelText: transactionLabelText, type: "invoked_transaction", uuid, parent: parentId, label});
    group.push(deleteButton);
    group.push(buttonContainer);
    if(messageButton != undefined ) group.push(messageButton);


    // Render oneof and condition
    const pathLength = Math.abs(x2 - x1);
    const showAttributeLabel = pathLength > 400;
    const attributeData = {
      name: transaction?.name,
      condition: invokedData?.condition,
      loop: invokedData?.loop
    }
    this.renderAttributesForChildTransactions({id: uuid, isInvoked:true, src: fromId, dst: toId, y, group, data: attributeData, showAttributeLabel, invoked: true})

    this.nodeManager.incrementLevelAndUpdatePlusIcons();

    const drawnItem = {
      transactionId,
      id: uuid,
      type: "invoked_transaction",
      parentId: parentId,
      transactionPath,
      group,
      // arrowHead,
      startCircle,
      endCircle,
      verticalDragHandler,
      transactionLabelBox,
      transactionLabelText,
      deleteButton: [deleteButton, buttonContainer],
      y,
      highlightElement: transactionLabelBox,
      messageButton : [ messageButton, messageSchemaButtonContainer]
    };

    this.invokedTransactions[uuid] = drawnItem;
    this.transactionElemnts[uuid] = drawnItem;
    this.draggableItems.push({
      id: uuid,
      transactionId,
      type: "invoked_transaction",
      group: group,
      y: y,
      height: this.verticalDragSpacing,
      elements: {
        eventArrowPath : transactionPath, labelRectangle: transactionLabelBox, labelText : transactionLabelText, verticalDragHandler
      }
    });

    this.drawnInvokedTransactions.push({ yPosition: y, id: transactionId, path: transactionPath });
    return group;
  }


  

  dragAndReorderVertical(entityId) {
    try {
      let currentIndex = this.draggableItems.findIndex(item => item.id === entityId);

      let entityData = this.transactionElemnts[entityId];
      let originalY = this.draggableItems[currentIndex]?.y;

      // const placeholder = this.paper.rect(0, 0, 180, 2).attr({ stroke: "#aaa", "stroke-dasharray": "-", "stroke-width": 2 }).hide();
      const placeholder = this.paper.path("M0,0L180,0")
        .attr({
          stroke: "#aaa",
          "stroke-width": 2,
          "stroke-dasharray": "-", // This creates a dotted pattern
          "stroke-linecap": "round"
        })
        .hide();

      let handler = entityData.verticalDragHandler; // To use the vertical drag handler of the entity
      let isScheduled = false; // To prevent multiple requestAnimationFrame calls
      let invokedProperties = null;

      const { handleDragMove, resetScroll, getScrollDelta } = enableVerticalAutoScrollOnDrag();


      handler.drag(
        // ON DRAG
        (dx, dy,  x, y, event) => {
          // console.log("ON DRAG MOVE ------------------------")
          if (!isScheduled) {
            isScheduled = true;
            requestAnimationFrame(() => {
              removeDragHandlerFromEventAndChildTxn({
                entityId,
                events: Object.values(this.eventArrows),
                childTxns: Object.values(this.childTransactions),
                invokedTxns: Object.values(this.invokedTransactions)
              });

              handleDragMove(event);

              let draggedEntity = this.transactionElemnts[entityId];
              let newY = originalY + dy; // To calculate the new Y position based on the original Y and the drag distance
              isScheduled = false;

              // Calculate new position including scroll adjustment
              newY = newY + getScrollDelta();

              // To collapse child transaction if it is in expanded state
              if (this.expandedChildTransactions[entityId]) { 
                this.handleInnerElementsOnChildTransactionReorder({entityId, draggedEntity})
              }

              const labelRectBbbox = draggedEntity.labelRectangle ? draggedEntity.labelRectangle.getBBox() : draggedEntity.transactionLabelBox.getBBox();
              const labelRectHeight = labelRectBbbox.height / 2;

              draggedEntity.oldY = draggedEntity.currentY ? draggedEntity.currentY : originalY;
              draggedEntity.currentY = newY;

              updateGroupYPosition({eventData: draggedEntity, newY, boxHeight: labelRectHeight, animate:false, Raphael});

              const shiftedIndexes = new Set(); // Keep track to prevent duplicate shifts


              for (let i = 0; i < this.draggableItems.length; i++) {
                if (i === currentIndex) continue;

                const dependentEntityY = this.draggableItems[i].y ;


                const direction = newY > dependentEntityY ? 1 : -1;
                const dySwap = direction * this.verticalDragSpacing;


                if (this.draggableItems[i].type === "child_transaction" && this.transactionBackgrounds[this.draggableItems[i].id]) { // To change child transaction background when drag through bottom
                  let bg = this.transactionBackgrounds[this.draggableItems[i].id];
                  const bgY = bg.attr("y");
                  const bgHeight = bg.attr("height");

                  let matchedRects = [];
                  let pId  = draggedEntity.parentId;
                  
                  Object.entries(this.transactionBackgrounds).map(([id, data]) => {
                    const bgBbox = data.getBBox();
                    if (bgBbox && newY >= bgBbox.y && newY  <= (bgBbox.y + bgBbox.height)) {
                      matchedRects.push({ id, height: bgBbox.height });
                    }
                  });

                  if (matchedRects.length > 0) {
                    matchedRects.sort((a, b) => a.height - b.height);
                    pId = matchedRects[0].id;
                  }

                  if(newY <= (bgY + bgHeight) && newY >= (dependentEntityY - 20)){
                    if (draggedEntity.oldY >= (bgY + bgHeight)) { // Moving into from bottom to top
                      console.log("Moving into from bottom to top")
                      bg.animate({ height: bgHeight + this.verticalDragSpacing }, 200, "easeInOut");
                    }
                  
                    draggedEntity.newParentId = pId;
                  } else if((newY > (bgY + bgHeight) || newY < (dependentEntityY + 20))){
                    console.log("Outside the elemnt")
                    if (draggedEntity.oldY <= (bgY + bgHeight) && newY > (bgY + bgHeight )) { // Moving out into bottom
                      bg.animate({ height: bgHeight - this.verticalDragSpacing }, 200, "easeInOut");
                      delete draggedEntity.newParentId;
                      console.log("Moving out into bottom")
                    }
                  }
                }

                if (!shiftedIndexes.has(this.draggableItems[i].id) && Math.abs(newY - dependentEntityY) < 14) {
                  // Find swap index
                  const swapIndex = i;
                  const swapItem = this.transactionElemnts[this.draggableItems[swapIndex].id];
                  const placeholderY = swapItem.y;
                  const swapItemBbox = swapItem.group[0].getBBox();
                  const labelRectBbbox = swapItem.labelRectangle ? swapItem.labelRectangle.getBBox() : swapItem.transactionLabelBox.getBBox();
                  const lebelRectHeight = labelRectBbbox.height / 2;

                  const swapItemY = this.draggableItems[swapIndex].y;
                  const newSwapY = this.draggableItems[swapIndex].y + dySwap;
                  const swapItemParentId = swapItem.parentId;

                  if (this.draggableItems[i].type === "child_transaction" && this.expandedChildTransactions[this.draggableItems[swapIndex].id]) { // To swap background with child transaction line
                    let bg = this.transactionBackgrounds[this.draggableItems[swapIndex].id];
                    if (bg) {
                      const bgY = bg.attr("y");
                      const bgHeight = bg.attr("height");
                      bg.animate({ y: bgY + dySwap }, 200, "easeInOut");
                      bg.animate({ height: bgHeight - dySwap }, 200, "easeInOut");
                      draggedEntity.newParentId = direction === 1 ? swapItemParentId : swapItem.id;
                    }
                  }

                  swapItem.deleteButton.forEach(item => item.remove());

                  updateGroupYPosition({eventData: swapItem, newY: newSwapY, boxHeight: lebelRectHeight, animate:true, Raphael});

                  this.draggableItems[swapIndex].y = newSwapY;

                  const draggedPath = entityData.eventArrowPath ? entityData.eventArrowPath.attr("path") : entityData.transactionPath.attr("path"); // e.g., [["M", 100, 50], ["L", 200, 100]]
                  const [start, end] = draggedPath;
                  const [_, startX, startY] = start;
                  const [__, endX, endY] = end;


                  if(entityData !== undefined  && entityData.type === "event") placeholder.attr({ "arrow-end": "classic-wide-long"});

                  placeholder.attr({
                    path: `M${startX},${placeholderY} L${endX},${placeholderY}`,
                  }).show();
                  this.draggableItems[currentIndex].y = swapItemY;
                  shiftedIndexes.add(this.draggableItems[i].id);
                }
              }
            });
          }
        },

        //  ON DRAG START
        () => {
          console.log("ON DRAG START ------------------------")
          if(this.removeExistingInlineInput) this.removeExistingInlineInput()
          
            
          let draggedEntity = this.transactionElemnts[entityId];
          this.sortDraggableItems();
          currentIndex = this.draggableItems.findIndex(item => item.id === entityId);
          originalY = this.draggableItems[currentIndex].y;
          placeholder.hide();

          this.nodeManager.globalPopUpSet?.remove();
          this.nodeManager.popupSetElements = {};
          this.nodeManager.popupBufferRect = {};

          if(draggedEntity?.type === "invoked_transaction"){
            const parentTxnData = this.transactions.find(item => item._id === draggedEntity.parentId);
            invokedProperties = parentTxnData?.invokedTransactions?.find(item => item?.uuid === entityId) || {};
          }
        },

        // ON DRAG END
        () => {
          console.log("ON DRAG END ------------------------")

          resetScroll();
          placeholder.hide();

          let draggedEntity = this.transactionElemnts[entityId];
          if (originalY === draggedEntity.y) {
            console.log("============No position changed==============")
            this.diagramManager?.clearAllElements();
            this.diagramManager?.init();
            return;
          }

          if ((originalY - (this.verticalDragSpacing / 2)) < draggedEntity.y && draggedEntity.y < (originalY + (this.verticalDragSpacing / 2)))  {
            console.log("============No reorderng==============")
            this.lastExpandedChild = null;
            this.diagramManager?.clearAllElements();
            this.diagramManager?.init();
            return;
          }
          
          // const bbox = draggedEntity.group[0].getBBox();
          // const labelRectBbox = draggedEntity.labelRectangle ? draggedEntity.labelRectangle.getBBox() : draggedEntity.transactionLabelBox.getBBox();
          // const labelRectHeight = labelRectBbox.height / 2;
          // updateGroupYPosition({eventData: draggedEntity, newY: this.draggableItems[currentIndex].y, pathX: bbox.x, pathWidth: bbox.width, boxHeight: labelRectHeight, animate: true, Raphael});

          const parentTransaction = this.transactions.find(item => item._id === draggedEntity.parentId);
          const oldParentTransaction =  parentTransaction ? parentTransaction : this.selectedTransaction;
          let newParentTransaction = this.transactions.find(item => item._id === draggedEntity.newParentId) || this.selectedTransaction;
          
          const transactionToUpdateOrder = newParentTransaction ? newParentTransaction : oldParentTransaction;

          if(newParentTransaction?._id?.toString() !== oldParentTransaction?._id?.toString()){
              if (draggedEntity.type === "event") {
                transactionToUpdateOrder.events.push({id: draggedEntity.id, order: draggedEntity.y});
                const transactionToRemoveEntity = this.transactions.find(item => item._id.toString() === oldParentTransaction?._id?.toString());
                transactionToRemoveEntity.events = transactionToRemoveEntity.events.filter(item => item.id !== draggedEntity.id);
              } else if ( draggedEntity.type === "child_transaction") {
                transactionToUpdateOrder.nestedTransactions.push({id: draggedEntity.id, order: draggedEntity.y});
                const transactionToRemoveEntity = this.transactions.find(item => item._id.toString() === oldParentTransaction?._id?.toString());
                transactionToRemoveEntity.nestedTransactions = transactionToRemoveEntity.nestedTransactions.filter(item => item.id !== draggedEntity.id);
              } else if ( draggedEntity.type === "invoked_transaction") {
                transactionToUpdateOrder.invokedTransactions.push({...invokedProperties, uuid: draggedEntity.id, order: draggedEntity.y});

                const transactionToRemoveEntity = this.transactions.find(item => item._id.toString() === oldParentTransaction?._id?.toString());
                transactionToRemoveEntity.invokedTransactions = transactionToRemoveEntity.invokedTransactions.filter(item => item.uuid !== draggedEntity.id);
              }
          }

          const updatedOrder = updateElementsOrder({selectedTransaction: transactionToUpdateOrder, draggableItems: this.draggableItems, verticalDragSpacing: this.verticalDragSpacing, invokedProperties});

          const transactionToAddEntity = this.transactions.find(item => item._id.toString() === newParentTransaction?._id?.toString());
          transactionToAddEntity.events = updatedOrder.events;
          transactionToAddEntity.nestedTransactions = updatedOrder.nestedTransactions;
          transactionToAddEntity.invokedTransactions = updatedOrder.invokedTransactions;

          const updatedSelectedTransaction = this.transactions.find(item => item._id.toString() === this.selectedTransaction._id.toString());
          this.diagramManager.updateTransactionData({transactions: this.transactions, selectedTransaction: updatedSelectedTransaction});
          this.diagramManager?.clearAllElements();
          this.diagramManager?.init();

          const dragPayload = {
            draggedEntityId: entityId,
            oldParentId: oldParentTransaction?._id,
            newParentId: newParentTransaction?._id,
            updatedOrder: updatedOrder,
            draggedEntityType: draggedEntity.type
          }
          this.triggerVerticalReorderAPI(dragPayload);
        }
      );

    } catch (error) {
      console.error(`Rerodering elements failed.`, error);
      this.diagramManager?.clearAllElements();
      this.diagramManager?.init();
      return null;
    }
  }

  triggerVerticalReorderAPI = (dragPayload) => {
    this.dispatch(invokePostService('updateTransactionElementsOrder', dragPayload, [this.selectedTransaction._id])).then((response) => {
          if (response.status) {
            this.diagramManager.preventCompleteRerender = true;
            this.diagramManager.preventConstructsUpdate = true;
            this.dispatch(handleSnackBar({ open: true, message: 'Elements reordered', severity: 'success' }));
          }else{
            this.dispatch(handleSnackBar({ open: true, message: 'Elements reorder failed', severity: 'error' }));
          }
          this.dispatch(setReRender());
        });
  }


  sortDraggableItems() {
    this.draggableItems.sort((a, b) => a.y - b.y);
  }

  // Allow child transactions and events to reorder
  dragEventAndTransactionsToReorder(){
    Object.keys(this.transactionElemnts)?.forEach(id => {
      this.dragAndReorderVertical(id);
    })

  }


  renderCirclesOnPotentialDropPositions(event, node){

    const doesConnectionExist = node?.doesConnectionExist;
    let alertLabel = null;
    const circle = renderCircleOnNode(this.paper, node?.x, event?.y, node?.doesConnectionExist)
    if(!doesConnectionExist){
      alertLabel = renderNoConnectionAlert({x: node?.x, y: event?.y, paper: this.paper, labelBoxConfig: this.labelBoxConfig});
    }

    this.nodeCircles.push({circle, alertLabel});
  }



  // Save the extended event in the DB
  saveEventOnExtending(event, targetId, onrecv){
    let updatedEvent = {
      ...event,
      dst: targetId,
      attributes: {...event.attributes, onrecv: onrecv }
    }
    if(updatedEvent?.instance === null || updatedEvent?.instance === undefined || updatedEvent?.instance === "") delete updatedEvent?.instance;

    const payload = {
      eventId: event?._id,
      event: updatedEvent,
      selectedEvent: event,
      selectedTransactionId: this.diagramManager?.selectedTransaction._id,
      messageData: null
    }


    this.dispatch(invokePostService('updateEvent', payload, [event?._id]))
        .then(response => {
          if (response?.status) {
            this.diagramManager.preventCompleteRerender = true;
            this.dispatch(handleSnackBar({ open: true, message: 'Event target updated', severity: 'success' }));
          } else {
            this.dispatch(handleSnackBar({ open: true, message: 'Extending event failed', severity: 'error' }));
            console.error( `Extending event failed. ${response?.message || ""}`)
          }
          this.dispatch(setReRender());


      }).catch(error => {
        this.dispatch(setReRender());
        console.error(`Saving updated event in the DB failed. ${error}`);
      });
  }


  findPotentialOnrecvHandlerCandidates({id, name, target, message}){
    const similarEvents = this.diagramManager?.events?.filter(item => item?._id !== id && item?.name === name && item?.message === message && item?.dst === target);

    const eventWithOnrecvHandler = similarEvents?.find(item => item?.attributes?.onrecv);

    return {onrecv: eventWithOnrecvHandler ? true : false, similarEvents};
  }

  findEventArrowElement(id){
    const event = Object.values(this.eventArrows)?.find(ele => ele?.id ===  id);

    return event;
  }


  handleEventOnStopDragging(eventElement, nearbyNode){

    const event = this.diagramManager?.events?.find(item => item?._id === eventElement?.id);
    const target = this.clusterlets?.find(item => item?._id === nearbyNode);
    const isTargetDelegate = target?.type === 1 ? true : false;
    const onrecvInitialState = event?.attributes?.onrecv;

    let potentialOnrecvHandlerCandidates = null;
    let onrecv = isTargetDelegate ? false :  event?.attributes?.onrecv ;
    if(!isTargetDelegate){
      if(onrecv){
        potentialOnrecvHandlerCandidates = this.findPotentialOnrecvHandlerCandidates({id: event?._id, name: event?.name, source: event?.src, target: nearbyNode, message: event?.message || ""})?.similarEvents;
      }else{
        // Check possibility of any similar events that existing with an onrecv handler
        // Similar events - Event with same target, same name,and same message type
        onrecv = this.findPotentialOnrecvHandlerCandidates({id: event?._id, name: event?.name, source: event?.src, target: nearbyNode, message: event?.message || ""})?.onrecv || false;
      }
    }



    let data = {};
    const onrecvCandidateIds = potentialOnrecvHandlerCandidates?.map(item => item?._id) || [];
    const updatedEvents = this.events?.map(eventData => {
      if(eventData?._id === eventElement?.id){
        eventData  = {
          ...event,
          dst: nearbyNode,
          attributes: {...eventData.attributes, onrecv: onrecv}
        }
      }

      if(onrecvCandidateIds?.includes(eventData?._id)) eventData.onrecv = true;

      return eventData;
    })
    data.events = updatedEvents;
    this.diagramManager.focusElement = {id: eventElement?.id, type: "event"};
    this.diagramManager.preventCompleteRerender = true;
    this.lastExpandedChild = null;
    this.diagramManager?.updateTransactionData(data);
    this.diagramManager?.clearAllElements();
    this.diagramManager?.init();

    this.saveEventOnExtending(event, nearbyNode, onrecvInitialState);
  }


   findNearbyNodeOnEventExtending(event, newX, nodes, proximity) {
    let nearbyNode = null;
    for (const node of nodes) {
      const lowerBound = node?.x - proximity;
      const upperBound = node?.x + proximity;

      if (newX >= lowerBound && newX <= upperBound) {
        nearbyNode = node;
        break;
      }
    }

    removeNodeCircles(this.nodeCircles);

    if(nearbyNode){
      this.renderCirclesOnPotentialDropPositions(event, nearbyNode)
    }else{
      hideAllCirclesOnNode({nodeCircles: this.nodeCircles});
    }
    return nearbyNode || null;
  }
  

  resetDraggingEventElementsOnIDrop(){
    this.diagramManager?.clearAllElements();
    this.diagramManager?.init();
  }

  // Drag and extend a single event
  dragAndExtendEvent({event}){
    if(event?.horizontalDragHandler === null || event?.horizontalDragHandler === undefined){
      return;
    }
    const _this = this;

    const dragHandlerX = event?.horizontalDragHandler?.attrs?.x;

    const isEventToRight =  event?.lineStart < event?.lineEnd ? true : false ;
    let nearbyNode = null;
    let potentialNodes = null;

    const { handleDragMove, resetScroll, getScrollDelta } = enableHorizontalAutoScrollOnDrag();


    event?.horizontalDragHandler?.drag(
      // On drag move
      function onMove(dx, dy, x, y, mouseEvent) {

        handleDraggingEventElements(event);

        handleDragMove(mouseEvent);

        let newArrowEndX =  event?.lineEnd + dx;
        let dragHandlerNewX = dragHandlerX + dx;

        // Update path of the event
        if(isEventToRight){
          newArrowEndX = newArrowEndX < event?.lineStart ? newArrowEndX - 40 : newArrowEndX;
        }else{
          newArrowEndX = newArrowEndX > event?.lineStart ? newArrowEndX + 40 : newArrowEndX;
        }

        // Adjust the drag handle during the scroll
        newArrowEndX =  newArrowEndX + getScrollDelta();
        dragHandlerNewX = dragHandlerNewX  + getScrollDelta();

        event?.horizontalDragHandler?.attr({x: dragHandlerNewX})
        event?.horizontalDragHandler?.show();
        event?.eventArrowPath?.attr({
          path: `M${event?.lineStart},${event?.y} L${newArrowEndX},${event?.y}`,
        })

        // Find nearby node
        nearbyNode = _this.findNearbyNodeOnEventExtending(event, newArrowEndX, potentialNodes, 75)
      },


      // On drag start
      function onDragStart(){
        if(_this.removeExistingInlineInput) _this.removeExistingInlineInput()
        const source = _this.nodeManager?.nodes[event?.source];
        const target = _this.nodeManager?.nodes[event?.target];
        potentialNodes = getNewEventTargetsOnEventDrag({nodes: _this.nodeManager?.nodes, connections: _this.connections, event: event, source, target, allClusterlets: _this.nodeManager?.clusterlets});
        removeNodeCircles(_this.nodeCircles);
      },


      // On drag end
      function onDragEnd() {
        resetScroll();
        removeNodeCircles(_this.nodeCircles);

        if(nearbyNode == null){
          _this.resetDraggingEventElementsOnIDrop();
        }

        // Drop on invalid node
        if(!nearbyNode?.doesConnectionExist){
          _this.resetDraggingEventElementsOnIDrop();

        }else{
          _this.handleEventOnStopDragging(event, nearbyNode?.id);
        }

        potentialNodes = null;
      }
    );


  }



hideAddRoundIcon(){
  Object.values(this.nodeManager.nodes).forEach(data => {
    data.plusCircle.hide();
  })
}

showAddRoundIcon(){
  Object.values(this.nodeManager.nodes).forEach(data => {
    data.plusCircle.show()
  })
}

findLastElementInTheChildren({ children = [], expandedList = {} }) {
  if (!Array.isArray(children) || children.length === 0) {
    return null;
  }

  const findLastItem = (childArray) => {
    const lastItem = childArray[childArray.length - 1];
    const isExpanded = !!expandedList[lastItem?.id];

    if (
      lastItem?.type === "nested" &&
      Array.isArray(lastItem?.children) &&
      lastItem.children.length > 0 &&
      isExpanded
    ) {
      return findLastItem(lastItem.children);
    }

    return lastItem;
  };

  return findLastItem(children);
};

renderBackgroundForChildTransaction({transactionId, children, expandedList, lastExpandedChild, eventElements, childTxnElements, invokedTxnElements, firstLevelChild=false}) {
  const transactionObj = this.transactions?.find(item => item?._id === transactionId);
  if (!transactionObj) {
    console.error(`Transaction with ID ${transactionId} not found.`);
    return;
  }
  const childTransactionElement = Object.values(this.childTransactions)?.find(item => item?.id === transactionId);
  const depth = findDepth(children, expandedList);

  const topPadding = 20;
  const bottomPadding = 40;
  const leftRightPadding = 20 * depth;

  const fromId = childTransactionElement?.source;
  const toId = childTransactionElement?.target;
  const startNode = Object.values(this.nodeManager?.nodes)?.find(item => item?.id === fromId);
  const endNode = Object.values(this.nodeManager?.nodes)?.find(item => item?.id === toId);
  const defaultHeight = 60 + bottomPadding;
  const doAnimation = lastExpandedChild && lastExpandedChild === transactionId ? true : false;

  const nodesXDelta = endNode?.x - startNode?.x;

  const backgroundColor1 = "#8a8d8f"

  const backgroundFill = firstLevelChild ? `url(#child-diagonalStripe)` : backgroundColor1;
  const rectOpacity = firstLevelChild ? 0.7 :  0.4;

  const rectX = startNode?.x - leftRightPadding;
  const rectY = childTransactionElement?.y ;
  const rectWidth = nodesXDelta + (2 * leftRightPadding);


  // Find last element in the children
  const lastItemInChildren = children?.length > 0 ? children[children?.length-1] : null;
  let lastItemElement = null;
  if(lastItemInChildren){
    if(lastItemInChildren?.type === "event"){
      lastItemElement = eventElements?.find(item => item?.id === lastItemInChildren?.id);
    }else if(lastItemInChildren?.type === "nested"){
      lastItemElement = childTxnElements?.find(item => item?.id === lastItemInChildren?.id);
    }else if(lastItemInChildren?.type === "invoked"){
      lastItemElement = invokedTxnElements?.find(item => item?.id === lastItemInChildren?.uuid);
    }
  }


  let rectHeight = defaultHeight;

  if(children?.length > 0 ){
      if(lastItemInChildren?.type === "nested" && expandedList[lastItemInChildren?.id]){

        const backgroundRectHeight = lastItemElement?.childWrapperRectangleHeight;
        const rectEndY = lastItemElement?.y + backgroundRectHeight;
        rectHeight = rectEndY - childTransactionElement?.y + bottomPadding;

      }else{
        const deltaY = lastItemElement?.y - childTransactionElement?.y - 20;
        rectHeight =  deltaY + topPadding + bottomPadding;
        rectHeight = rectHeight + 20;
      }
  }


  let backgroundRect = null;
  if(doAnimation){
    backgroundRect = this.paper
      .rect(rectX, rectY, rectWidth, 0) // Start with height 0
      .attr({
        stroke: 'black',                 // border color
        'stroke-width': 1,              // thickness of the border
        'stroke-dasharray': '-',
        'fill-opacity': rectOpacity
      });

    // Animate the height from 0 to desired value
    backgroundRect.animate(
      { height: rectHeight },
      150,          // duration in ms
      'easeIn'      // easing (can be 'linear', 'easeOut', etc.)
    );

  }else{
    backgroundRect = this.paper.rect(rectX, rectY, rectWidth, rectHeight).attr({
        stroke: 'black',                 // border color
        'stroke-width': 1,              // thickness of the border
        'stroke-dasharray': '-',
        'fill-opacity': rectOpacity
    })

  }
  // Set the fill directly on the SVG DOM node
  backgroundRect.node.setAttribute("fill", backgroundFill);
  backgroundRect.node.setAttribute("id", `child_${transactionObj?.name}_background`);
  backgroundRect.node.setAttribute("data-ui-tour-id", `child_transaction`);


  backgroundRect.toBack();

  this.transactionBackgrounds[transactionId] = backgroundRect;
  this.childTransactions[transactionId] = {
    ...childTransactionElement,
    childWrapperRectangle: backgroundRect,
    childWrapperRectangleHeight: rectHeight
  };


}

getChildrenCount(children, expandedList){
   let count = 0

   children?.forEach(item => {
    count = count + 1
    if(item === "nested" && expandedList[item?.id]){
      count = count + this.getChildrenCount(item?.children, expandedList)
    }
   })

   return count;
}

  renderPlusIconPopup(x, y, targetId, parentId, nestedTransactionPlusIconYPsition) {
    const group = this.paper.set(); // Group for all popup elements

    const plusCircle = this.nodeManager.createPlusCircle(x, y);
    group.push(plusCircle);

    this.nodesForPlusCircle[targetId] = {plusCircle}

    const bottomIcon = this.nodeManager.createPopupIcon(this.paper, x, y + this.nodeManager.popupIconOffset, this.nodeManager.childTransactionIconPath, "bottom", targetId, this.nodeManager.popupIconSize);
    const leftIcon = this.nodeManager.createPopupIcon(this.paper, x - this.nodeManager.popupIconOffset, y, this.nodeManager.leftEventIconPath, "left", targetId, this.nodeManager.popupIconSize);
    const rightIcon = this.nodeManager.createPopupIcon(this.paper, x + this.nodeManager.popupIconOffset, y, this.nodeManager.rightEventIconPath, "right", targetId, this.nodeManager.popupIconSize);
    group.push(bottomIcon, leftIcon, rightIcon);
    const popupSet = this.paper.set().push(bottomIcon, leftIcon, rightIcon);


    const padding = 10;
    const plusBox = plusCircle.getBBox();
    const iconsBox = group.getBBox(); // Get bbox of the entire popup group

    const bufferX = Math.min(plusBox.x, iconsBox.x) - padding;
    const bufferY = Math.min(plusBox.y, iconsBox.y) - padding;
    const bufferWidth = Math.max(plusBox.x + plusBox.width, iconsBox.x + iconsBox.width) - bufferX + padding;
    const bufferHeight = Math.max(plusBox.y + plusBox.height, iconsBox.y + iconsBox.height) - bufferY + padding;

    const hoverBuffer = this.paper.rect(bufferX, bufferY, bufferWidth, bufferHeight).attr({
        fill: "transparent",
        stroke: "none"
    });
    hoverBuffer.toBack();
    group.push(hoverBuffer); // Add hover buffer to the group

    // Attach hover behavior using NodeManager's method
    this.nodeManager.attachHoverBehavior(plusCircle, popupSet, targetId, hoverBuffer);

    // Attach click handlers using NodeManager's method
    const plusX = plusBox.x + plusBox.width / 2; // Central X for click handlers
    rightIcon.click(() => this.nodeManager.handlePopupClick("right", popupSet, plusX, rightIcon.data("id"),plusCircle, parentId, nestedTransactionPlusIconYPsition));
    leftIcon.click(() => this.nodeManager.handlePopupClick("left", popupSet, plusX, leftIcon.data("id"), plusCircle,parentId, nestedTransactionPlusIconYPsition));
    bottomIcon.click(() => this.nodeManager.handlePopupClick("bottom", popupSet, plusX, bottomIcon.data("id"), plusCircle, parentId, nestedTransactionPlusIconYPsition)); // Corrected ID for bottomIcon

    return group; // Return the entire popup group
}

  updatePlusIcons(updatedY) {
    const newY = updatedY;
    Object.values(this.nodesForPlusCircle).forEach(node => {
      node?.plusCircle.attr({ y: newY });
    });
  }

  updateGroupYPositionWithDelta = (eventData, deltaY, animate = false) => {
    eventData.group.forEach(el => {
      const type = el.type;

      if (type === "rect" || type === "image") {
        const x = el.attr("x");
        const y = el.attr("y") + deltaY;
        if (animate) {
          el.animate({ x, y }, 200, "easeInOut");
        } else {
          el.attr({ x, y });
        }

      } else if (type === "text") {
        const x = el.attr("x");
        const y = el.attr("y") + deltaY;
        if (animate) {
          el.animate({ x, y }, 200, "easeInOut");
        } else {
          el.attr({ x, y });
        }

      } else if (type === "circle") {
        const cx = el.attr("cx");
        const cy = el.attr("cy") + deltaY;
        if (animate) {
          el.animate({ cx, cy }, 200, "easeInOut");
        } else {
          el.attr({ cx, cy });
        }

      } else if (type === "path" && (el === eventData.eventArrowPath || el === eventData.transactionPath)) {
        const pathArray = Raphael.parsePathString(el.attr("path"));
        const updatedPath = pathArray.map(cmd => {
          if (cmd[0] === "M" || cmd[0] === "L") {
            return [cmd[0], cmd[1], cmd[2] + deltaY];
          }
          return cmd;
        });
        if (animate) {
          el.animate({ path: updatedPath }, 200, "easeInOut");
        } else {
          el.attr({ path: updatedPath });
        }

      } else if (el === eventData.startShape) {
        const x = eventData.startX;
        const apex = eventData.apexLength;
        const base = eventData.baseHeight;
        const newY = eventData.y + deltaY;
        const pathStr = `M${x},${newY - base} L${x},${newY + base} L${x - apex},${newY} Z`;
        if (animate) {
          el.animate({ path: pathStr }, 200, "easeInOut");
        } else {
          el.attr({ path: pathStr });
        }

      } else if (el === eventData.endShape) {
        const x = eventData.endX;
        const apex = eventData.apexLength;
        const base = eventData.baseHeight;
        const newY = eventData.y + deltaY;
        const pathStr = `M${x},${newY - base} L${x},${newY + base} L${x + apex},${newY} Z`;
        if (animate) {
          el.animate({ path: pathStr }, 200, "easeInOut");
        } else {
          el.attr({ path: pathStr });
        }
      }
    });

    // Update internal Y tracker
    eventData.y += deltaY;
    if(eventData.yPosition)  eventData.yPosition += deltaY;
  };



  incrementPlusIcons(updatedY) {
    this.updatePlusIcons(updatedY);
  }

  async handleChildtransactionCollapse(id){
    const childElement = this.childTransactions[id];
    const childrenInOrder = childElement?.children ;
    const expandItems = this.expandedChildTransactions;
    const allChildTxns = Object.values(this.childTransactions) || [];

    if(!childrenInOrder || childrenInOrder.length === 0){
      await removeRectsFromBottomToTop([childElement?.childWrapperRectangle])
      return;
    }

    const tranactionsInChildren = childrenInOrder?.filter(item => item?.type === "nested" && expandItems[item?.id])?.map(item => item?.id) || [];
    const childrenRectangles = allChildTxns?.filter(item => tranactionsInChildren.includes(item?.id))?.map(item => item?.childWrapperRectangle) || [];

    const allGroups = childrenInOrder.map(child => this.eventArrows[child.id]?.group).filter(group => group);
    if(allGroups?.length > 0) await removeArrowGroups(allGroups);

    await removeRectsFromBottomToTop([...childrenRectangles]);
    await removeRectsFromBottomToTop([childElement?.childWrapperRectangle])

  }


  getDrawnItems(){
    return {drawnEvents : this.drawnEvents, drawnChildTransactions : this.drawnChildTransactions}
  }

  triggerUpdateElementNameApi(elementId, name, type) {

    this.dispatch(invokePostService('updateTransactionElementName', { elementData : {elementId, name, type} }, [this.selectedTransaction._id]))
      .then((savedData) => {
        if (savedData.status) {
          this.diagramManager.preventCompleteRerender = true;
          this.diagramManager.preventConstructsUpdate = true;
        } else {
          if (Array.isArray(savedData?.errors) && savedData.errors[0] !== undefined && savedData.errors[0].message !== undefined) {
            this.dispatch(handleSnackBar({ open: true, message: savedData.errors[0].message, severity: 'error' }));
          }
        }
        this.dispatch(setReRender());

      })
      .catch(error => {
        this.dispatch(setReRender());
        console.error("Failed to update the name. ", error);
        this.dispatch(handleSnackBar({ open: true, message: "Failed to update the name.", severity: 'error' }));
      });

  }

  // To remove the inner elements in the child transaction on child transaction dragging
  handleInnerElementsOnChildTransactionReorder = ({entityId, draggedEntity}) => {
    this.expandedChildTransactions[entityId] = false; // To collapse the child transaction
    draggedEntity.expandButton.attr({ src: this.icons.collapseIcon }); // To change the icon to collapse
    const elementsToRemove = getElementsToRemoveOnDrag(entityId, this.transactions, this.events, this.draggableItems, this.expandedChildTransactions, []);
    for (const element of elementsToRemove) {  // To remove the events inside the child transaction
      if (element.type === "child_transaction") {
        this.expandedChildTransactions[element.id] = false;
        this.transactionElemnts[element.id].expandButton.attr({ src: this.icons.collapseIcon });
        this.transactionElemnts[element.id]?.group?.remove();
        delete this.transactionElemnts[element.id];
        this.transactionBackgrounds[element.id]?.remove(); // To clear the background of expanded nested child transaction
        this.drawnChildTransactions = this.drawnChildTransactions.filter(item => item.id !== element.id);
      } else if (element.type === "event") {
        this.eventArrows[element.id]?.group?.remove();
        delete this.eventArrows[element.id];
      } else if (element.type === "invoked_transaction") {
        this.invokedTransactions[element.id]?.group?.remove();
        delete this.invokedTransactions[element.id];
        delete this.transactionElemnts[element.id];
        this.drawnInvokedTransactions = this.drawnInvokedTransactions.filter(item => item.id !== element.id);
      }
      this.draggableItems = this.draggableItems.filter(item => item.id !== element.id);
    }
    this.transactionBackgrounds[entityId].remove(); // To clear the background of child transaction
  }


  

}
